import { batch } from 'react-redux';

import { DataStorageEnums, Key } from 'dashboard-services/api/dataStorage';
import { ActionService, CommonService, ReduxService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';
import { globalActions, loginActions } from 'primary-components';

import { basicPipelineCreatorActions } from 'actions/modules/datascience/creator';
import { routing } from 'routing';
import { customInsightSelectors } from 'selectors/modules/insight/custom';
import { getIsInsightSelfActivated } from 'services/LocalStorageService.js';
import ReferenceDataService from 'services/ReferenceDataService';

import WorkspaceUtils from 'components/modules/DataScience/PipelineCreator/Body/Workspace/WorkspaceUtils';
import Diagram from 'components/modules/Insight/CustomInsight/ChartInsight/tiles/DiagramTile/Content/Diagram';

import { templatesInsightActions } from '../';
import { inputParamsCustomInsightActions, searchCustomInsightActions } from './';
import basicCustomInsightConsts from './basicConsts.js';
import chartCustomInsightActions from './chart.js';
import diagramCustomInsightActions from './diagram.js';
import tableCustomInsightActions from './table.js';

import { Point } from '@projectstorm/geometry';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';
import { Parser } from 'ng-expr-eval';
import { InsightEngineError, InsightFactory, InsightIssueCode } from 'ng-insight-engine';
import { parse } from 'papaparse';

const { getInputParamsConfig } = customInsightSelectors
export default (() => {
  const { AXIS_TYPES, EMPTY_TILE, ENGINE_TILE_ACCESSORS, ENGINE_TILE_ADDERS, ENGINE_TILE_TYPES, TILE_TYPES, BUTTON_TYPES } = basicCustomInsightConsts
  const { CHART_SOURCES } = chartCustomInsightActions

  const getProxy = () => (_dispatch, getState) => {
    const { groupName, fileName } = getState().insightState.customState.info,
          editActive = getState().insightState.customState.editActive
    const isPublicDirectory = String(window.location.pathname).startsWith(`/${routing.public.name}`)
    if(editActive) {
      return undefined;
    }
    if(groupName === undefined && fileName === undefined) {
      return;
    }
    return `/insight/${isPublicDirectory ? `public/` : ``}proxy/${groupName}/${fileName}`
  }

  const addChartTile = navigate => dispatch => dispatch(addTile(EMPTY_TILE[TILE_TYPES.CHART], navigate))
  const addEngineTile = ({ tileType, navigate }) => (dispatch, getState) => {
    const customState = getState().insightState.customState,
          content = customState.content,
          insertAfterIndex = typeof customState.prevSelectedTile === 'number' ? customState.prevSelectedTile : undefined,
          beforeTileId = insertAfterIndex === undefined ? undefined : content.tiles?.[insertAfterIndex + 1]?.id,
          builder = InsightFactory.from({ insight: content }),
          tile = ENGINE_TILE_ADDERS[tileType](builder, { beforeTileId }),
          nextContent = builder.snapshot(),
          url = window.location.pathname + window.location.search

    navigate(`${url}#`, { replace: true })
    setTimeout(() => navigate(`${url}#${tile.title()}`, { replace: true }), 5)
    dispatch(onChange(basicCustomInsightConsts.ACTIVE_PANEL.TILE_EDIT, 'activePanel'))
    dispatch(addEngineTileReducer(nextContent, tile.id()))
  }
  const addTextTile = navigate => addEngineTile({ tileType: TILE_TYPES.TEXT, navigate })
  const addTableTile = navigate => dispatch => dispatch(addTile(EMPTY_TILE[TILE_TYPES.TABLE], navigate))
  const addCodeTile = navigate => addEngineTile({ tileType: TILE_TYPES.CODE, navigate })
  const addPDFTile = navigate => addEngineTile({ tileType: TILE_TYPES.PDF, navigate })
  const addImageTile = navigate => addEngineTile({ tileType: TILE_TYPES.IMAGE, navigate })
  const addAutoPipelineTile = navigate => dispatch => dispatch(addTile(EMPTY_TILE[TILE_TYPES.AUTO_PIPELINE], navigate))
  const addStatusTile = navigate => addEngineTile({ tileType: TILE_TYPES.STATUS, navigate })
  const addSearchTile = navigate => dispatch => dispatch(addTile(EMPTY_TILE[TILE_TYPES.SEARCH], navigate))
  const addStatsTile = navigate => dispatch => dispatch(addTile(EMPTY_TILE[TILE_TYPES.STATS], navigate))
  const addDiagramTile = navigate => dispatch => {
    const ToastsStore = dispatch(globalActions.getToastsStore())
    const diagram = new Diagram(ToastsStore)
    dispatch(addTile(Object.assign({}, EMPTY_TILE[TILE_TYPES.DIAGRAM], { diagram }), navigate))
  }

  const ON_CHANGE_TILE = 'ON_CHANGE_TILE_CUSTOM_INSIGHT'
  const onChangeTile = ActionService.makeActionCreator(ON_CHANGE_TILE, 'value', 'name', 'index')

  const ON_CHANGE_TILE_ITEM = 'ON_CHANGE_TILE_ITEM_CUSTOM_INSIGHT'
  const onChangeTileItem = ActionService.makeActionCreator(ON_CHANGE_TILE_ITEM, 'value', 'name', 'itemName', 'index')

  const ON_CHANGE_TILE_OVERWRITE_ITEM = 'ON_CHANGE_TILE_OVERWRITE_ITEM_CUSTOM_INSIGHT'
  const onChangeTileOverwriteItem = ActionService.makeActionCreator(ON_CHANGE_TILE_OVERWRITE_ITEM, 'value', 'name', 'tileId')

  const setTileName = ({ tileName, tileIndex }) => (dispatch, getState) => {
    const tileNames = (getState().insightState.customState.content?.tiles || []).map(tile => tile?.title)
    const suffix = "(1)"
    let newName = tileName
    newName = newName.replace(basicCustomInsightConsts.TILE_NAME_REGEXP, "") // remove from tile title chracters other than letters, numbers, ()_-
    while(tileNames.some(tileName => tileName === newName)) {
      newName = `${newName}${suffix}`
    }
    dispatch(onChangeTile(newName, "title", tileIndex))  
  }

  const getNewTileName = (tiles, title) => {
    const suffix = "(1)"
    let newName = title
    while(tiles.some(tile => tile.title === newName)) {
      newName = `${newName}${suffix}`
    }
    return newName
  }
  const ADD_TILE = 'ADD_TILE_CUSTOM_INSIGHT'
  const addTile = (emptyTile, navigate) => (dispatch, getState) => {
    const tiles = getState().insightState.customState.content?.tiles || []
    const newTitle = getNewTileName(tiles, emptyTile.title)
    const url = window.location.pathname + window.location.search
    navigate(`${url}#`, { replace: true })
    setTimeout(() => navigate(`${url}#${newTitle}`, { replace: true }), 5)
    dispatch(onChange(basicCustomInsightConsts.ACTIVE_PANEL.TILE_EDIT, 'activePanel'))
    dispatch(addTileReducer(Object.assign({}, emptyTile, { title: newTitle, id: CommonService.generateUID() })))
  }

  const addTileReducer = ActionService.makeActionCreator(ADD_TILE, 'tile')

  const addEngineTileReducer = ActionService.makeActionCreator(ADD_TILE, 'content', 'tileId')

  const ADD_HEADER_BOX = 'ADD_HEADER_BOX_CUSTOM_INSIGHT'
  const addHeaderBox = ActionService.makeActionCreator(ADD_HEADER_BOX)


  const ADD_FOOTER_BUTTON = 'ADD_FOOTER_BUTTON_CUSTOM_INSIGHT'
  const addFooterButton = ActionService.makeActionCreator(ADD_FOOTER_BUTTON)

  const ADD_FOOTER = 'ADD_FOOTER_CUSTOM_INSIGHT'
  const addFooter = ActionService.makeActionCreator(ADD_FOOTER)

  const DUPLICATE_TILE = 'DUPLICATE_TILE_CUSTOM_INSIGHT'
  const duplicateTile = (index, navigate) => (dispatch, getState) => {
    const customState = getState().insightState.customState,
          tiles = customState.content?.tiles || [],
          tile = tiles[index]
    const url = window.location.pathname + window.location.search

    if(ENGINE_TILE_TYPES.includes(tile?.type)) {
      const content = customState.content,
            builder = InsightFactory.from({ insight: content }),
            duplicate = builder.duplicateTile(tile.id),
            nextContent = builder.snapshot()

      navigate(`${url}#${duplicate.title()}`, { replace: true })
      dispatch(duplicateEngineTileReducer(nextContent, index))

      const partnerAssets = customState.tilePartnerAssets?.[tile.id] || {},
            duplicatedTile = nextContent.tiles?.find(nextTile => nextTile.id === duplicate.id())
      duplicatedTile?.partners?.forEach(partner => {
        const asset = partnerAssets[partner.id]
        if(asset?.file) {
          const imageUrl = typeof URL?.createObjectURL === 'function' ? URL.createObjectURL(asset.file) : undefined
          dispatch(setTilePartnerAsset({ tileId: duplicate.id(), partnerId: partner.id, file: asset.file, imageUrl }))
        }
      })
      return
    }

    // TODO(insight-engine-migration): non-Engine duplicate still runs through the DUPLICATE_TILE reducer.
    // When the Engine owns all generic tile types, route these through InsightBuilder.duplicateTile too.
    const newTitle = getNewTileName(tiles, tiles[index].title)
    navigate(`${url}#${newTitle}`, { replace: true })
    dispatch(duplicateTileReducer(index, newTitle))
  }
  const duplicateTileReducer = ActionService.makeActionCreator(DUPLICATE_TILE, 'index', 'newTitle')
  const duplicateEngineTileReducer = ActionService.makeActionCreator(DUPLICATE_TILE, 'content', 'index')

  const DELETE_TILE = 'DELETE_TILE_CUSTOM_INSIGHT'
  const deleteTileReducer = ActionService.makeActionCreator(DELETE_TILE, 'index')
  const deleteEngineTileReducer = ActionService.makeActionCreator(DELETE_TILE, 'content', 'index')
  const deleteTile = index => (dispatch, getState) => {
    const tile = getState().insightState.customState.content?.tiles?.[index]

    if(ENGINE_TILE_TYPES.includes(tile?.type)) {
      const content = getState().insightState.customState.content,
            builder = InsightFactory.from({ insight: content })
      builder.removeTile(tile.id)
      dispatch(deleteEngineTileReducer(builder.snapshot(), index))
      dispatch(clearTilePartnerAsset({ tileId: tile.id }))
      return
    }

    // TODO(insight-engine-migration): non-Engine delete still runs through the DELETE_TILE reducer.
    // When the Engine owns all generic tile types, route these through InsightBuilder.removeTile too.
    dispatch(deleteTileReducer(index))
  }

  const DELETE_FOOTER = 'DELETE_FOOTER_CUSTOM_INSIGHT'
  const deleteFooter = ActionService.makeActionCreator(DELETE_FOOTER, 'index')

  const DELETE_HEADER_BOX = 'DELETE_HEADER_BOX_CUSTOM_INSIGHT'
  const deleteHeaderBox = ActionService.makeActionCreator(DELETE_HEADER_BOX, 'index')

  const DELETE_FOOTER_BUTTON = 'DELETE_FOOTER_BUTTON_CUSTOM_INSIGHT'
  const deleteFooterButton = ActionService.makeActionCreator(DELETE_FOOTER_BUTTON, 'index')

  const REORDER_FOOTER_BUTTON = 'REORDER_FOOTER_BUTTON_CUSTOM_INSIGHT'
  const reorderFooterButton = ActionService.makeActionCreator(REORDER_FOOTER_BUTTON, 'from', 'to')

  const DUPLICATE_HEADER_BOX = 'DUPLICATE_HEADER_BOX_CUSTOM_INSIGHT'
  const duplicateHeaderBox = ActionService.makeActionCreator(DUPLICATE_HEADER_BOX, 'index')

  const REORDER_HEADER_BOX = 'REORDER_HEADER_BOX_CUSTOM_INSIGHT'
  const reorderHeaderBox = ActionService.makeActionCreator(REORDER_HEADER_BOX, 'from', 'to')

  const reorderTile = ({ tileIndex, hoveredIndex }) => (dispatch, getState) => {
    const customState = getState().insightState.customState,
          tiles = customState.content.tiles
    const newTiles = tiles.moveItem(tileIndex, hoveredIndex)
    newTiles.forEach((localTile, localTileIndex) => {
      if(localTile.type === TILE_TYPES.DIAGRAM) {
        localTile.diagram.getActiveModel().getNodes()?.forEach(node => {
          node.options.index = localTileIndex 
        })
      }
    })

    dispatch(onChangeContent(newTiles, 'tiles'))
  }

  const clearChartTile = index => (dispatch, getState) => {
    const tiles = getState().insightState.customState.content.tiles,
          oldTile = tiles[index],
          newTile = Object.assign({}, EMPTY_TILE[TILE_TYPES.CHART], { actions: oldTile?.actions, partners: oldTile?.partners, title: oldTile?.title, id: oldTile?.id, tileWidth: oldTile?.tileWidth, tileHeight: oldTile?.tileHeight, basicChartType: oldTile?.basicChartType }),
          newTiles = tiles.replace(newTile, index)
    dispatch(onChangeContent(newTiles, 'tiles'))
  }

  const onChangeTileSourceValue = ({ tileIndex, value, paramName }) => (dispatch, getState) => {
    const currentSource = getState().insightState.customState.content.tiles[tileIndex]?.source;
    dispatch(onChangeTile({
      ...currentSource,
      value: {
        ...currentSource.value || {},
        [paramName]: value
      }
    }, "source", tileIndex))
  }

  const ON_CHANGE = 'ON_CHANGE_CUSTOM_INSIGHT'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const editEngineTile = ({ tileId, operation }) => (dispatch, getState) => {
    const content = getState().insightState.customState.content,
          tileType = content.tiles?.find(tile => tile.id === tileId)?.type,
          builder = InsightFactory.from({ insight: content })

    let operationResult
    try {
      operationResult = operation(ENGINE_TILE_ACCESSORS[tileType](builder, tileId))
    } catch (error) {
      if(error instanceof InsightEngineError && error.issue.code === InsightIssueCode.TEXT_TILE_TITLE_EMPTY) {
        dispatch(globalActions.getMessageStore()).error(error.message)
        return undefined
      }
      throw error
    }

    const nextContent = builder.snapshot()
    if (nextContent === content) {
      return operationResult
    }

    dispatch(onChange(nextContent, 'content'))
    return operationResult
  }

  const editTextTile = ({ tileId, operation }) => editEngineTile({ tileId, operation })
  const editPdfTile = ({ tileId, operation }) => editEngineTile({ tileId, operation })
  const editImageTile = ({ tileId, operation }) => editEngineTile({ tileId, operation })
  const editCodeTile = ({ tileId, operation }) => editEngineTile({ tileId, operation })
  const editStatusTile = ({ tileId, operation }) => editEngineTile({ tileId, operation })
  // STATUS Filter and PipelineItem options address their element by UI index, as before the engine;
  // the stable ID is read from the latest content when the change is dispatched.
  const editStatusTileItem = ({ tileIndex, listName, itemIndex, operation }) => (dispatch, getState) => {
    const tile = getState().insightState.customState.content?.tiles?.[tileIndex],
          itemId = tile?.[listName]?.[itemIndex]?.id

    return dispatch(editStatusTile({ tileId: tile?.id, operation: statusTile => operation({ statusTile, itemId }) }))
  }

  const SET_TILE_PARTNER_ASSET = 'SET_TILE_PARTNER_ASSET_CUSTOM_INSIGHT'
  const setTilePartnerAssetReducer = ActionService.makeActionCreator(SET_TILE_PARTNER_ASSET, 'tileId', 'partnerId', 'file', 'imageUrl')
  const setTilePartnerAsset = ({ tileId, partnerId, file, imageUrl }) => (dispatch, getState) => {
    const previousUrl = getState().insightState.customState.tilePartnerAssets?.[tileId]?.[partnerId]?.imageUrl
    if(previousUrl && typeof URL?.revokeObjectURL === 'function') {
      URL.revokeObjectURL(previousUrl)
    }
    dispatch(setTilePartnerAssetReducer(tileId, partnerId, file, imageUrl))
  }

  const CLEAR_TILE_PARTNER_ASSET = 'CLEAR_TILE_PARTNER_ASSET_CUSTOM_INSIGHT'
  const clearTilePartnerAssetReducer = ActionService.makeActionCreator(CLEAR_TILE_PARTNER_ASSET, 'tileId', 'partnerId')
  const clearTilePartnerAssetsReducer = ActionService.makeActionCreator(CLEAR_TILE_PARTNER_ASSET, 'tileId')
  const clearTilePartnerAsset = ({ tileId, partnerId }) => (dispatch, getState) => {
    const asset = getState().insightState.customState.tilePartnerAssets?.[tileId]?.[partnerId]
    if(asset?.imageUrl && typeof URL?.revokeObjectURL === 'function') {
      URL.revokeObjectURL(asset.imageUrl)
    }
    dispatch(clearTilePartnerAssetReducer(tileId, partnerId))
  }
  const clearTilePartnerAssets = () => (dispatch, getState) => {
    const assets = getState().insightState.customState.tilePartnerAssets || {}
    if(typeof URL?.revokeObjectURL === 'function') {
      Object.values(assets).forEach(tileAssets => Object.values(tileAssets || {}).forEach(asset => {
        if(asset?.imageUrl) {
          URL.revokeObjectURL(asset.imageUrl)
        }
      }))
    }
    dispatch(clearTilePartnerAssetsReducer())
  }

  const ON_CHANGE_INFO = 'ON_CHANGE_INFO_CUSTOM_INSIGHT'
  const onChangeInfo = ActionService.makeActionCreator(ON_CHANGE_INFO, 'value', 'name')

  const ON_CHANGE_CONTENT = 'ON_CHANGE_CONTENT_CUSTOM_INSIGHT'
  const onChangeContent = ActionService.makeActionCreator(ON_CHANGE_CONTENT, 'value', 'name')

  const ON_CHANGE_INFO_FIELD = 'ON_CHANGE_INFO_FIELD_CUSTOM_INSIGHT'
  const onChangeInfoField = ActionService.makeActionCreator(ON_CHANGE_INFO_FIELD, 'value', 'name')

  const ON_CHANGE_HEADER_BOX = 'ON_CHANGE_HEADER_BOX_CUSTOM_INSIGHT'
  const onChangeHeaderBox = ActionService.makeActionCreator(ON_CHANGE_HEADER_BOX, 'value', 'name', 'index')

  const ON_CHANGE_FOOTER = 'ON_CHANGE_FOOTER_CUSTOM_INSIGHT'
  const onChangeFooter = ActionService.makeActionCreator(ON_CHANGE_FOOTER, 'value', 'name')

  const ON_CHANGE_FOOTER_BUTTON = 'ON_CHANGE_FOOTER_BUTTON_CUSTOM_INSIGHT'
  const onChangeFooterButton = ActionService.makeActionCreator(ON_CHANGE_FOOTER_BUTTON, 'value', 'name', 'index')

  const ON_ADD_TILE_LIST = 'ON_ADD_TILE_LIST_CUSTOM_INSIGHT'
  const onAddTileList = ActionService.makeActionCreator(ON_ADD_TILE_LIST, 'item', 'listName', 'tileIndex')

  const ON_CHANGE_TILE_LIST = 'ON_CHANGE_TILE_LIST_CUSTOM_INSIGHT'
  const onChangeTileList = ActionService.makeActionCreator(ON_CHANGE_TILE_LIST, 'value', 'name', 'listName', 'listIndex', 'tileIndex')

  const ON_REMOVE_TILE_LIST = 'ON_REMOVE_TILE_LIST_CUSTOM_INSIGHT'
  const onRemoveTileList = ActionService.makeActionCreator(ON_REMOVE_TILE_LIST, 'listName', 'listIndex', 'tileIndex')

  const ON_REORDER_TILE_LIST = 'ON_REORDER_TILE_LIST_CUSTOM_INSIGHT'
  const onReorderTileList = ActionService.makeActionCreator(ON_REORDER_TILE_LIST, 'listName', 'from', 'to', 'tileIndex')

  const SET_TABLE_TS_DATA = 'SET_TABLE_TS_DATA_CUSTOM_INSIGHT'
  const setTableTsData = ActionService.makeActionCreator(SET_TABLE_TS_DATA, 'symbols', 'values', 'index')

  const SET_DATA_PREP = 'SET_DATA_PREP_CUSTOM_INSIGHT'
  const setDataPrep = ActionService.makeActionCreator(SET_DATA_PREP, 'dataprep', 'index')

  const SET_SHORT_DATA_PREP = 'SET_SHORT_DATA_PREP_CUSTOM_INSIGHT'
  const setShortDataPrep = ActionService.makeActionCreator(SET_SHORT_DATA_PREP, 'dataprep', 'index')

  const doesColumnExist = (symbol, column) => 
    CommonService.getTSColumnName(symbol.valueColumnName, { offsetAmount: symbol.offsetAmount, offsetType: symbol.offsetType, fillType: symbol.fillType }) === column 
    || symbol?.valueColumnNames.findIndex(c => CommonService.getTSColumnName(c,  { offsetAmount: symbol.offsetAmount, offsetType: symbol.offsetType, fillType: symbol.fillType }) === column) > -1

  const DUPLICATE_TILE_ID_MSG = "A tile with this ID already exists. The imported tile will get a new ID and won't stay connected to related tiles."

  const ANY = {
    label: "Any",
    value: "*",
    tooltip: "Should be only used, if the key does not influence the uniqueness of the set of keys and metadatas.",
    tooltipPosition: "left"
  }
  const searchValuesInDataPrep = ({
    dataprepDownloaded, 
    symbolList = [], 
    key, 
    column, 
    groupName, 
    input, 
    keyAsTime, 
    keyAsTimeSymbol, 
    columnXAxis, 
    withAny = false
  }) =>
    new Promise(resolve => {
      resolve(() => {
        const symbolsInDp = dataprepDownloaded?.symbols || []
        const filterSymbols = (symbolList || []).filter(s => s.fixedValue && s.name !== key && s.fixedValue !== "*")
        const set = new Set(symbolsInDp
          .filter(symbol => doesColumnExist(symbol, column))
          .filter(symbol => (groupName && symbol.groupName === groupName) || (symbolList?.[0]?.groupName && symbolList?.[0]?.groupName === symbol.groupName))
          .filter(symbol => {
            let match = true
            filterSymbols.forEach(({ name, fixedValue }) => {
              if(symbol.symbol[name] !== fixedValue) {
                match = false;
              }
              if(keyAsTime && symbol.symbol[keyAsTimeSymbol] === undefined) {
                match = false;
              } else if(!keyAsTime && columnXAxis && symbol.symbol[columnXAxis] === undefined) {
                match = false;
              }
            })
            return match
          })
          .map(symbol => symbol.symbol[key])
          .filter(value => {
            if(input) {
              try {
                return value && value.toLowerCase().search(input.toLowerCase()) > -1
              } catch {
                // invalid regexp, we will skip it
              }
            }
            return true;
          })
        )
        const array = Array.from(set).sort((a, b) => String(a).localeCompare(b)).map(val => ({ label: val, value: val }))
        if(withAny) {
          array.unshift(ANY)
        }
        return array;
      })
    })

  const searchMetadataInDataPrep = (dataprepDownloaded, symbolList = [], key, column, groupName, input, keyAsTime, keyAsTimeSymbol, columnXAxis) =>
    new Promise(resolve => {
      resolve(() => {
        const symbolsInDp = dataprepDownloaded?.symbols || []
        const filterSymbols = (symbolList || []).filter(s => s.fixedValue && s.name !== key && s.fixedValue !== "*")
        const set = new Set(symbolsInDp
          .filter(symbol => doesColumnExist(symbol, column))
          .filter(symbol => (groupName && symbol.groupName === groupName) || (symbolList?.[0]?.groupName && symbolList?.[0]?.groupName === symbol.groupName))
          .filter(symbol => {
            let match = true
            filterSymbols.forEach(({ name, fixedValue }) => {
              if(symbol.symbol[name] !== fixedValue) {
                match = false;
              }
              if(keyAsTime && symbol.symbol[keyAsTimeSymbol] === undefined) {
                match = false;
              } else if(!keyAsTime && columnXAxis && symbol.symbol[columnXAxis] === undefined) {
                match = false;
              }
            })
            return match
          })
          .filter(symbol => symbol.symbol[key] !== undefined)
          .flatMap(symbol => Object.keys(symbol.metadata))
          .filter(value => {
            if(input) {
              try {
                return value && value.toLowerCase().search(input.toLowerCase()) > -1
              } catch {
                // invalid regexp, we will skip it
              }
            }
            return true;
          })
        )
        const array = Array.from(set).sort((a, b) => String(a).localeCompare(b)).map(val => ({ label: val, value: val }))
        return array;
      })
    })

  const getColumnsFromDataPrep = dataprepDownloaded => dispatch => {
    if(!dataprepDownloaded || !dataprepDownloaded?.symbols) {
      return []
    }
    const symbolsLocal = dataprepDownloaded?.symbols || []
    const toReturn = new Set()
    symbolsLocal.forEach(symbol => {
      if(symbol?.pattern && (symbol.valueColumnName === "*" || symbol.valueColumnNames?.[0] === "*")) {
        dispatch(globalActions.getMessageStore()).error("Pattern symbols with all columns selected are not supported.")
      } else {
        if(symbol?.valueColumnName) {
          toReturn.add(CommonService.getTSColumnName(symbol?.valueColumnName, { offsetAmount: symbol.offsetAmount, offsetType: symbol.offsetType, fillType: symbol.fillType }))
        } else {
          (symbol?.valueColumnNames || []).forEach(v => toReturn.add(CommonService.getTSColumnName(v, { offsetAmount: symbol.offsetAmount, offsetType: symbol.offsetType, fillType: symbol.fillType })))
        }
      }
    })
    return Array.from(toReturn)
  }

  const getGroupsFromDataPrep = dataprepDownloaded => {
    if(!dataprepDownloaded || !dataprepDownloaded?.symbols) {
      return []
    }
    const symbolsLocal = dataprepDownloaded?.symbols || []
    const toReturn = new Set()
    symbolsLocal.forEach(symbol => toReturn.add(symbol.groupName))
    return Array.from(toReturn)
  }

  const getSymbolsFromDataPrep = (dataprepDownloaded, column, groupName) => {
    if(!dataprepDownloaded || !column) {
      return []
    }
    const toReturn = new Set()
    const symbolsLocal = dataprepDownloaded?.symbols || []
    symbolsLocal
      .filter(symbol => doesColumnExist(symbol, column))
      .filter(symbol => groupName && symbol.groupName === groupName)
      .forEach(symbol => {
          Object.keys(symbol.symbol).forEach(key => {
            toReturn.add(key)
          })
      })
    return Array.from(toReturn);
  }

  const getFullSymbols = ({ dataprepDownloaded, symbolList, key, column, groupName, keyAsTime, keyAsTimeSymbol, columnXAxis }) => {
    const symbolsInDp = dataprepDownloaded?.symbols || []
    const filterSymbols = (symbolList || []).filter(s => s.fixedValue && s.name !== key && s.fixedValue !== "*")
    return symbolsInDp
      .filter(symbol => doesColumnExist(symbol, column))
      .filter(symbol => (groupName && symbol.groupName === groupName) || (symbolList?.[0]?.groupName && symbolList?.[0]?.groupName === symbol.groupName))
      .filter(symbol => {
        let match = true
        filterSymbols.forEach(({ name, fixedValue }) => {
          if(symbol.symbol[name] !== fixedValue) {
            match = false;
          }
          if(keyAsTime && symbol.symbol[keyAsTimeSymbol] === undefined) {
            match = false;
          } else if(!keyAsTime && columnXAxis && symbol.symbol[columnXAxis] === undefined) {
            match = false;
          }
        })
        return match
      })
  }

  const getKeysAndMdKeysFromDataPrep = dataprepDownloaded => {
    if(!dataprepDownloaded) {
      return [];
    }
    const toReturn = new Set()
    dataprepDownloaded.symbols.forEach(symbol => {
      Object.keys(symbol.symbol || {}).forEach(key => toReturn.add(key))
      Object.keys(symbol.metadata || {}).forEach(key => toReturn.add(key))
    })
    return Array.from(toReturn)
  }

  const tickFormatter = (val, { unit, unitOnFront, formatDomainOperation, formatDomainValue, formatDomainUnit = "", noEnter = false, axisType, sourceType, dateFormat = undefined, decimalPrecision = undefined } = {}) => {
    let evaluatedVal = val
    if(decimalPrecision) {
      evaluatedVal = Number(evaluatedVal).toFixed(decimalPrecision)
    }
    if(formatDomainOperation && formatDomainValue !== undefined && formatDomainValue !== "") {
      try {
        if (!/^[0-9+\-*/().\s]+$/.test(formatDomainOperation) || !/^[0-9+\-*/().\s]+$/.test(formatDomainValue)) {
          throw new Error("Invalid characters in formatDomainOperation or formatDomainValue");
        }
        const expr = Parser.parse(`${evaluatedVal}${formatDomainOperation}${formatDomainValue}`);
        evaluatedVal = String(expr.evaluate({}));
      } catch(e) {
        console.error(e)
      }
    }
    const afterFormatOperation = (formatDomainOperation && formatDomainValue !== undefined && formatDomainValue !== "") || (decimalPrecision !== undefined && decimalPrecision !== "")  ? evaluatedVal : val
    const shouldKeepDateLabelAsIs = dateFormat !== undefined && axisType !== AXIS_TYPES.NUMBER.value
    let valueWithSeparator = CommonService.isNumber(afterFormatOperation) && !shouldKeepDateLabelAsIs && ((sourceType !== CHART_SOURCES.FILE.value && dateFormat !== "yyyy") || axisType === AXIS_TYPES.NUMBER.value) && !decimalPrecision ? Number(afterFormatOperation).toLocaleString('en-US') : afterFormatOperation
    if(valueWithSeparator.length > 9 && !noEnter) {
      valueWithSeparator = valueWithSeparator.replace(",", ",\n")
    }
    if(formatDomainOperation && formatDomainUnit && val !== 0) {
      valueWithSeparator += formatDomainUnit
    }
    if(!unit || val === 0) {
      return valueWithSeparator;
    }
    if(unitOnFront === true) {
      return (valueWithSeparator < 0 ? "-" : "") + unit + (valueWithSeparator < 0 ? (valueWithSeparator * -1) : valueWithSeparator)
    }
    return valueWithSeparator + unit
  }

  const tooltipFormatter = (val, name, dataKey, leftTickFormatter, rightTickFormatter) => {
    if(val === null || val === undefined) {
      return [val, dataKey]
    }
    if(name === "left") {
      return [leftTickFormatter(val, true, true), dataKey]
    }
    return [rightTickFormatter(val, true, true), dataKey]
  }

  const getKey = ({ column, symbols = {}, groupName, pattern, patternExactMatch, offsetAmount, offsetType, fillType, avgPointsAmount }) => {
    if(Object.keys(symbols).length > 0) {
      const key = 
        new Key.Builder()
          .withColumns([column])
          .withSymbols(symbols)
          .withGroupName(groupName)
          .withPattern(pattern)
          .withPatternExactMatch(patternExactMatch)
          .withOffsetAmount(offsetAmount)
          .withOffsetType(offsetType)
          .withFillType(fillType)
          .withAvgPointsAmount(avgPointsAmount)
          .withSymbolValuesExactMatch(true)
      return key;
    }
    return undefined;
  }


  const getDataPrepIndex = (dataprepSymbols, symbols, column, groupName, withWildcard = true) => {
    const index = dataprepSymbols
      .findIndex(dps => {
        if(dps.groupName === groupName && (dps.valueColumnNames.findIndex(v => CommonService.getTSColumnName(v, { offsetAmount: dps.offsetAmount, offsetType: dps.offsetType, fillType: dps.fillType })?.toLowerCase() === String(column).toLowerCase()) > -1)) {
          let exist = true
          Object.entries(symbols).forEach(([k, v]) => {
            if(v !== dps.symbol[k] && (v !== "*" || !withWildcard)) {
              exist = false;
            }
          })
          return exist
        }
        return false;
      })
    return index;
  }

  const setUpDates = (dataprep, builder) => {
    if(dataprep.range === DataStorageEnums.DATA_RANGE.BETWEEN) {
      builder = builder
              .withStartDate(dataprep.dateFrom === "today" ? "today" : TimeService.getUserFormattedDate(Number(dataprep.dateFrom), dataprep.timezone || "UTC") + "T" + TimeService.getUserFormattedTime(Number(dataprep.dateFrom), dataprep.timezone || "UTC"))
              .withEndDate(dataprep.dateTo === "today" ? "today" : TimeService.getUserFormattedDate(Number(dataprep.dateTo), dataprep.timezone || "UTC") + "T" + TimeService.getUserFormattedTime(Number(dataprep.dateTo), dataprep.timezone || "UTC"))
    }
  
    if(dataprep.range === DataStorageEnums.DATA_RANGE.LAST || dataprep.range === DataStorageEnums.DATA_RANGE.NEXT) {
      builder = builder
              .withLastType(dataprep.lastType)
              .withLastTypeAmount(dataprep.lastTypeAmount)
              .withLastTypeOnTime(dataprep.lastTypeOnTime)
              .withLastTypeOnTimeTimezone(dataprep.lastTypeOnTimeTimezone)
              .withHolidayCalendar(dataprep.holidayCalendar)
    }
    return builder;
  }

  // source is the environment the group was used from; no source means the local environment
  const checkAndPush = ({ groups, groupName, access, isWorkflow = false, source }) => {
    if(groupName) {
      if(!groups[groupName]) {
        groups[groupName] = {
          access,
          usage: [],
          isWorkflow,
          sources: [source]
        }
      } else {
        if(!groups[groupName].sources.includes(source)) {
          groups[groupName].sources.push(source)
        }
        if(!isWorkflow) {
          groups[groupName].isWorkflow = isWorkflow
        }
        if(access && access !== "R")  {
          groups[groupName].access = access
        }
      }
    }
  }

  // Environments a search tile group was selected from (groupSources, saved only when groups are picked with All providers),
  // otherwise the chosen provider. groupSources are the only record of where a group comes from, so they win over the provider
  const getSearchTileGroupSources = ({ tile, groupName }) => {
    const groupSources = (tile.groupSources || []).filter(groupSource => groupSource.groupName === groupName).map(({ source }) => source)

    return groupSources.length > 0 ? groupSources : [basicCustomInsightConsts.getProviderTarget(tile.provider)]
  }

  // Temporary: backend cannot assign role entitlements for groups from external environments, so only groups used from the local environment are kept
  const isLocalGroup = ({ sources, localProvider }) => sources.some(source => !source || source === localProvider)

  const getInsightGroups = ({ getPipelineCall }) => async (_, getState) => {
    const datapreps = getState().insightState.customState.datapreps,
          tiles = getState().insightState.customState.content?.tiles,
          insightGroup = getState().insightState.customState.info?.groupName,
          headerBoxes = getState().insightState.customState.content?.headerBoxes,
          footerButtons = getState().insightState.customState.content?.footer?.buttons,
          inputParams = getState().insightState.customState.content?.inputParams,
          groups = {}
    
    const promises = []
    
    Object.values(datapreps || {}).forEach((dp, index) => {
      checkAndPush({ groups, groupName: dp?.outputGroup, access: "R", isWorkflow: false })
      groups[dp?.outputGroup]?.usage.push({ type: "Data prep", index, name: `${dp.name}`, tile: tiles?.[index]?.title })
      dp?.symbols.forEach(symbol => {
        checkAndPush({ groups, groupName: symbol.groupName, access: "R", isWorkflow: false })
        const usageIndex = groups[symbol.groupName]?.usage.findIndex(u => u.source === dp.name && u.index === index)
        if(usageIndex === -1) {
          groups[symbol.groupName]?.usage.push({ type: "Symbols", index, source: dp.name, count: 1, name: `(1) from data prep ${dp.name}`, tile: tiles?.[index]?.title })
        } else {
          groups[symbol.groupName].usage[usageIndex].count++; 
          groups[symbol.groupName].usage[usageIndex].name = `(${groups[symbol.groupName]?.usage[usageIndex].count}) from data prep ${dp.name}`
        }
      })
    });
    (headerBoxes || []).forEach((headerBox, index) => {
      checkAndPush({ groups, groupName: headerBox.symbol?.groupName, access: "R", isWorkflow: false })
      if(groups[headerBox.symbol?.groupName]?.usage.findIndex(u => u.name === headerBox.title) === -1) {
        groups[headerBox.symbol?.groupName]?.usage.push({ type: "Header Box", index, name: headerBox.title })
      }
    });
    (footerButtons || []).forEach((button, index) => {
      let groupName;
      if(button.type === BUTTON_TYPES.DOWNLOAD_FILE) {
        groupName = button?.file?.groupName;
        checkAndPush({ groups, groupName, access: "R", isWorkflow: false })
      } else if(button.type === BUTTON_TYPES.DOWNLOAD_DATA_PREP) {
        groupName = button?.dataprep?.groupName;
        checkAndPush({ groups, groupName, access: "RWS", isWorkflow: true })
      }
      if(groups[groupName]?.usage.findIndex(u => u.name === button.text) === -1) {
        groups[groupName]?.usage.push({ type: "Footer Button", index, name: button.text })
      }
    });
    Object.values(inputParams || {}).forEach((inputParam, index) => {
      if(inputParam.csvFile) {
        checkAndPush({ groups, groupName: inputParam.csvFile.groupName, access: "R", isWorkflow: false, source: inputParam.provider })
        if(groups[inputParam.csvFile.groupName]?.usage.findIndex(u => u.name === `File from ${inputParam.csvFile.groupName}`)) {
          groups[inputParam.csvFile.groupName]?.usage.push({ type: "Input parameters", index, name: `File from ${inputParam.csvFile.groupName}` })
        }
      } else {
        // All providers: the group is pushed with every environment it comes from (groupSources), only local ones get roles
        const groupEnvironments = basicCustomInsightConsts.isAllProviders(inputParam.provider)
          ? inputParamsCustomInsightActions.getGroupSources({ inputParams: inputParam })
          : [inputParam.provider]
        groupEnvironments.forEach(source => checkAndPush({ groups, groupName: inputParam.groupName, access: "R", isWorkflow: false, source }))
        if(groups[inputParam.groupName]?.usage.findIndex(u => u.name === `Symbols from ${inputParam.groupName}`)) {
          groups[inputParam.groupName]?.usage.push({ type: "Input parameters", index, name: `Symbols from ${inputParam.groupName}` })
        }
      }
    })
    tiles?.forEach((tile, index) => {
      if(tile.source?.value?.groupName) {
        checkAndPush({ groups, groupName: tile.source?.value?.groupName, access: "R", isWorkflow: false })
        if(groups[tile.source?.value?.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === tile.source?.value?.name) === -1) {
          groups[tile.source?.value?.groupName]?.usage.push({ type: tile?.source?.type, index, name: tile.source?.value?.name, tile: tile.title })
        }
      }
      Object.values(tile?.sourceSymbols || {}).forEach(s => {
        if(s?.groupName) {
          // A chart column from a specific provider keeps its environment, a column without it is from the local environment
          if(s.sources) {
            s.sources.forEach(source => checkAndPush({ groups, groupName: s.groupName, access: "R", isWorkflow: false, source }))
          } else {
            checkAndPush({ groups, groupName: s.groupName, access: "R", isWorkflow: false })
          }
          if(groups[s.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === Object.entries(s.symbols || {}).join(",")) === -1) {
            groups[s.groupName]?.usage.push({ type: tile?.source?.type, index, name: Object.entries(s.symbols || {}).join(","), tile: tile.title })
          }
        }
      })
      if(tile?.leftAxis?.data?.length > 0){
        tile?.leftAxis?.data.forEach(leftAxisData => {
          const dataId = leftAxisData?.label || leftAxisData?.root
          checkAndPush({ groups, groupName: leftAxisData?.groupName, access: "R", isWorkflow: false })
          if(groups[leftAxisData?.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === dataId) === -1) {
            groups[leftAxisData?.groupName]?.usage.push({ type: tile?.source?.type, index, name: dataId, tile: tile.title })
          }
        })
      }
      if(tile?.rightAxis?.data?.length > 0){
        tile?.rightAxis?.data.forEach(rightAxisData => {
          const dataId = rightAxisData?.label || rightAxisData?.root
          checkAndPush({ groups, groupName: rightAxisData?.groupName, access: "R", isWorkflow: false })
          if(groups[rightAxisData?.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === dataId) === -1) {
            groups[rightAxisData?.groupName]?.usage.push({ type: tile?.source?.type, index, name: dataId, tile: tile.title })
          }
        })
      }
      if(tile.pipeline) {
        checkAndPush({ groups, groupName: tile.pipeline.groupName, access: "R", isWorkflow: true })
        promises.push(
          getPipelineCall({ pipelineName: tile.pipeline.name, groupName: tile.pipeline.groupName, version: 'latest' })
              .then(response => {
                const taskDefs = 
                  response.batchConfig.tasks
                    .map(task => WorkspaceUtils.getTaskDef(response.taskDefinitions, task))
                const pipelineGroups = basicPipelineCreatorActions.getAllGroups(taskDefs) 
                pipelineGroups.forEach(() => {
                  if(groups[tile.pipeline.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === tile.pipeline.name) === -1) {
                    groups[tile.pipeline.groupName]?.usage.push({ type: "Pipeline", index, name: tile.pipeline.name, tile: tile.title })
                  }
                })
              })
              .catch(() => {})
        )
      }
      if(tile.columns?.length > 0) {
        tile.columns.forEach(({ columnDropdownGroupName, columnAsyncGroupName, columnId } = {}) => {
          if(columnDropdownGroupName) {
            checkAndPush({ groups, groupName: columnDropdownGroupName, access: "R", isWorkflow: false })
            if(groups[columnDropdownGroupName]?.usage.findIndex(u => u.tile === tile.title && u.name === columnId) === -1) {
              groups[columnDropdownGroupName]?.usage.push({ type: "Table column", index, name: columnId, tile: tile.title })
            }
          } else if(columnAsyncGroupName) {
            checkAndPush({ groups, groupName: columnAsyncGroupName, access: "R", isWorkflow: false })
            if(groups[columnAsyncGroupName]?.usage.findIndex(u => u.tile === tile.title && u.name === columnId) === -1) {
              groups[columnAsyncGroupName]?.usage.push({ type: "Table column", index, name: columnId, tile: tile.title })
            }
          }
        })
      }
      if(tile.passedFiles?.length > 0) {
        tile.passedFiles.forEach(({ value } = {}) => {
          checkAndPush({ groups, groupName: value.groupName, access: "R", isWorkflow: false })
          if(groups[value.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === value.name) === -1) {
            groups[value.groupName]?.usage.push({ type: "Code Files", index, name: value.name, tile: tile.title })
          }
        })
      }
      if(tile?.partners?.length > 0) {
        checkAndPush({ groups, groupName: insightGroup, access: "R", isWorkflow: false })
        if(groups[insightGroup]?.usage.findIndex(u => u.tile === tile.title && u.name === insightGroup) === -1) {
          groups[insightGroup]?.usage.push({ type: "Partners", index, name: insightGroup, tile: tile.title })
        }
      }
      if(tile?.params?.length > 0) {
        tile.params.forEach(param => {
          if(param.fileWithOptions?.groupName) {
            checkAndPush({ groups, groupName: param.fileWithOptions?.groupName, access: "R", isWorkflow: false })
            if(groups[param.fileWithOptions?.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === param.name) === -1) {
              groups[param.fileWithOptions?.groupName]?.usage.push({ type: `Param ${param.name}`, index, name: insightGroup, tile: tile.title })
            }
          }
        })
      }
      (tile.actions || []).filter(action => action.pipelineGroupName).forEach(action => {
        checkAndPush({ groups, groupName: action.pipelineGroupName, access: "R", isWorkflow: true })
        if(groups[action.pipelineGroupName]?.usage.findIndex(u => u.tile === tile.title && u.name === `${action.type} ${action.pipelineName}`) === -1) {
          groups[action.pipelineGroupName]?.usage.push({ type: "Action", index, name: `${action.type} ${action.pipelineName}`, tile: tile.title })
        }
      });
      (tile.actions || []).filter(action => action.groupName && action.fileType).forEach(action => {
        checkAndPush({ groups, groupName: action.groupName, access: "RWS", isWorkflow: true })
        if(groups[action.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === `${action.type} ${action.fileName}`) === -1) {
          groups[action.groupName]?.usage.push({ type: "Action", index, name: `${action.type} ${action.fileName}`, tile: tile.title })
        }
      })
      if(tile.statusFilters) {
        tile.statusFilters.filter(t => t.groupName).forEach(({ groupName, label } = {}) => {
          checkAndPush({ groups, groupName, access: "R", isWorkflow: true })
          if(groups[groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === label) === -1) {
            groups[groupName]?.usage.push({ type: "Status filter", index, name: label, tile: tile.title })
          }
        })
      }
      if(tile.pipelineItems) {
        tile.pipelineItems.filter(t => t.pipeline).forEach(({ pipeline, label } = {}) => {
          checkAndPush({ groups, groupName: pipeline.groupName, access: "R", isWorkflow: true })
          if(groups[pipeline.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === label) === -1) {
            groups[pipeline.groupName]?.usage.push({ type: "Status pipeline", index, name: label, tile: tile.title })
          }
        })
      }
      if(tile.nodes) {
        Object.values(tile.nodes).forEach(node => {
          if(node.pipeline) {
            checkAndPush({ groups, groupName: node.pipeline.groupName, access: "R", isWorkflow: true })
            if(groups[node.pipeline.groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === node.label) === -1) {
              groups[node.pipeline.groupName]?.usage.push({ type: "Diagram node", index, name: `${node.label}`, tile: tile.title })
            }
          }
        })
      }
      if(tile.filters) {
        tile.filters.forEach(filter => {
          if(filter.filterKey === searchCustomInsightActions.FILTER_TYPE.GROUP_NAME && !!filter.defaultValue) {
            // The tile uses only default groups that are also in its source groups (getSelectedGroupNames), the others get no roles.
            // Without this a leftover group would get the local environment and fail the role update ("Group not found.")
            searchCustomInsightActions.getGroupNamesFromFilter(filter.defaultValue)
              .filter(groupName => !(tile.groupNames?.length > 0) || tile.groupNames.includes(groupName))
              .forEach(groupName => {
                getSearchTileGroupSources({ tile, groupName }).forEach(source => checkAndPush({ groups, groupName, access: "R", isWorkflow: false, source }))
                if(groups[groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === filter.label) === -1) {
                  groups[groupName]?.usage.push({ type: "Search tile", index, name: `${filter.label}`, tile: tile.title })
                }
              })
          }
        })
      }
      if(tile.groupNames) {
        tile.groupNames.forEach(groupName => {
          getSearchTileGroupSources({ tile, groupName }).forEach(source => checkAndPush({ groups, groupName, access: "R", isWorkflow: false, source }))
          if(groups[groupName]?.usage.findIndex(u => u.tile === tile.title && u.name === groupName) === -1) {
            groups[groupName]?.usage.push({ type: "Search tile", index, name: groupName, tile: tile.title })
          }
        })
      }
    })
    await Promise.all(promises)
    // Every group used in the insight with the environments it is used from (sources, no source = local environment)
    return groups
  }

  // Groups that get insight roles: a group used only from external environments is left out
  const getInsightRoleGroups = ({ getPipelineCall }) => async (dispatch, getState) => {
    const groups = await dispatch(getInsightGroups({ getPipelineCall })),
          localProvider = getState().globalState?.providers?.find(provider => provider.producerId === 0)?.name
    return Object.fromEntries(Object.entries(groups).filter(([, { sources }]) => isLocalGroup({ sources, localProvider })))
  }

  // One entry per environment of a group: the local one (source undefined) and every external one, e.g. for links to the Data Lake
  const getGroupEnvironments = ({ sources = [], localProvider }) =>
    sources.map(source => !source || source === localProvider ? undefined : source).toUnique()

  const CLEAR_WITH_ID = 'CLEAR_WITH_ID_BASIC_CUSTOM_INSIGHT'
  const clearWithId = ActionService.makeActionCreator(CLEAR_WITH_ID)

  const getColumnConfigs = columns => 
    columns.filter(c => !c.withCondition).map(column => {
      if(column.columnId) {
        return column;
      } else {
        // withCondition, conditionValueA, condition, conditionValueB
        const newColumn =  {
          columnId: column.header,
          bgColor: column.bgColor,
          textAlign: column.textAlign,
          textColor: column.textColor,
          textStyle: column.textStyle,
          fontSize: column.fontSize,
          unit: column.unit,
          unitOnFront: column.unitOnFront,
          columnWidth: column.width ? Number(column.width) : undefined,
          withCondition: column.withCondition,
          condition: column.condition,
          conditionValueA: column.conditionValueA,
          conditionValueB: column.conditionValueB,
          isNumber: column.isNumber // thousand seperator
        }
        return newColumn;
      }
    })
  
  const getRowConfigs = rowConfigs => {
    const newRowConfigs = []
    const oldHeaderConfig = rowConfigs.find(rc => rc.rowNumber?.includes("Header") && !rc?.withCondition)
    if(oldHeaderConfig) {
      newRowConfigs.push({
        rowId: basicCustomInsightConsts.ROW_CONFIGS.HEADER,
        textAlign: oldHeaderConfig.textAlign,
        textColor: oldHeaderConfig.textColor,
        textStyle: oldHeaderConfig.textStyle,
        bgColor: oldHeaderConfig.bgColor,
        fontSize: oldHeaderConfig.fontSize,
      })
    } else {
      newRowConfigs.push(tableCustomInsightActions.getEmptyRowConfig(basicCustomInsightConsts.ROW_CONFIGS.HEADER))
    }
    const oldEvenConfig = rowConfigs.find(rc => rc.rowNumber?.includes('1') && rc.rowNumber?.includes('3') && !rc?.withCondition)
    if(oldEvenConfig) {
      newRowConfigs.push({
        rowId: basicCustomInsightConsts.ROW_CONFIGS.EVEN,
        textAlign: oldHeaderConfig.textAlign,
        textColor: oldEvenConfig.textColor,
        textStyle: oldEvenConfig.textStyle,
        bgColor: oldEvenConfig.bgColor,
        fontSize: oldEvenConfig.fontSize,
      })
    } else {
      newRowConfigs.push(tableCustomInsightActions.getEmptyRowConfig(basicCustomInsightConsts.ROW_CONFIGS.EVEN))
    }
    const oldOddConfig = rowConfigs.find(rc => rc.rowNumber?.includes('2') && rc.rowNumber?.includes('4') && !rc?.withCondition)
    if(oldOddConfig) {
      newRowConfigs.push({
        rowId: basicCustomInsightConsts.ROW_CONFIGS.ODD,
        textAlign: oldHeaderConfig.textAlign,
        textColor: oldOddConfig.textColor,
        textStyle: oldOddConfig.textStyle,
        bgColor: oldOddConfig.bgColor,
        fontSize: oldOddConfig.fontSize,
      })
    } else {
      newRowConfigs.push(tableCustomInsightActions.getEmptyRowConfig(basicCustomInsightConsts.ROW_CONFIGS.ODD))
    }
    newRowConfigs.push(tableCustomInsightActions.getEmptyRowConfig(basicCustomInsightConsts.ROW_CONFIGS.FOOTER))
    return newRowConfigs;
  }
  
  const getEmptyConditionalFormatting = ({ item, applyTo }) => ({
    textStyle: item.textStyle,
    textAlign: item.textAlign,
    textColor: item.textColor,
    bgColor: item.bgColor,
    fontSize: item.fontSize,
    applyTo,
    condition: item.condition === "=" ? tableCustomInsightActions.CONDITION.IS_EQUAL: item.condition,
    conditionValueA: item.conditionValueA,
    conditionValueB: item.conditionValueB
  })
  
  const getConditionalFormatting = ({ columns, rowConfigs }) => {
    const conditionalFormatting = []
    columns.filter(c => c.withCondition === true).forEach(c => conditionalFormatting.push(getEmptyConditionalFormatting({ item: c, applyTo: { columnId: c.header || c.columnId } })))
    rowConfigs.filter(r => r.withCondition === true).forEach(r => conditionalFormatting.push(getEmptyConditionalFormatting({ item: r, applyTo: { rowId: tableCustomInsightActions.CONDITION_ROW_IDS.ALL } })))
    return conditionalFormatting;
  }

  const normalizeCurveCsvHeaders = ({ csvHeaders, removeSymbolHeaders = false }) => {
    if(!Array.isArray(csvHeaders)) {
      return csvHeaders
    }
    return csvHeaders
      .filter(header => !removeSymbolHeaders || header?.type !== DataStorageEnums.CSV_HEADER_TYPE.SYMBOL_KEY)
      .map(header => header?.type === DataStorageEnums.CSV_HEADER_TYPE.SYMBOL_KEY
        ? { ...header, type: DataStorageEnums.CSV_HEADER_TYPE.METADATA_KEY }
        : header)
  }

  const normalizeInputParamValue = value => {
    if(value.dropdownOptions === undefined) {
      return value
    }
    const { dropdownOptions, ...valueWithoutDropdownOptions } = value
    delete valueWithoutDropdownOptions.dropdownOptions
    delete valueWithoutDropdownOptions.withFixedOptions
    if(value.fixedOptions !== undefined || value.fixedOptionsFile !== undefined) {
      return valueWithoutDropdownOptions
    }
    return {
      ...valueWithoutDropdownOptions,
      fixedOptions: dropdownOptions,
      fixedOptionsType: basicCustomInsightConsts.INPUT_PARAMS_FIXED_OPTIONS_TYPES.MANUAL
    }
  }

  const normalizeInputParamsPresets = ({ presets }) => presets.map(preset => {
    if(!('type' in preset) && !('dateRange' in preset)) {
      return preset
    }
    const { type, dateRange, ...current } = preset

    return {
      ...current,
      presetType: 'presetType' in current ? current.presetType : type,
      dateType: 'dateType' in current ? current.dateType : dateRange
    }
  })

  const getInputParams = orInputParams => {
    const ip = {}
    Object.entries(orInputParams).forEach(([k, v]) => {
      const newV = Object.assign({}, v)
      if(!v.basicInputParamsType) {
        newV.basicInputParamsType = inputParamsCustomInsightActions.BASIC_INPUT_PARAM_TYPES.TS.value
      }
      if(v.shouldSynchronizeParams === undefined) {
        newV.shouldSynchronizeParams = false;
      }
      if(newV.basicInputParamsType === inputParamsCustomInsightActions.BASIC_INPUT_PARAM_TYPES.CURVE.value) {
        newV.csvHeaders = normalizeCurveCsvHeaders({ csvHeaders: newV.csvHeaders })
      }
      if(v.values) {
        newV.values = v.values.map(normalizeInputParamValue)
      }
      if(v.presets) {
        newV.presets = normalizeInputParamsPresets({ presets: v.presets })
      }
      ip[k] = newV
    })
    return ip;
  }

  const getSeasonalityAxisData = ({ currentAxisData = {}, tile }) => {
    const shouldUseLegacyConfig = currentAxisData.column === undefined && tile.yColumn !== undefined
    return ReduxService.updateObject(currentAxisData, {
      chartType: currentAxisData.chartType || chartCustomInsightActions.CHART_TYPES.LINE.value,
      column: shouldUseLegacyConfig ? tile.yColumn : currentAxisData.column,
      dynamic: currentAxisData.dynamic === undefined ? false : currentAxisData.dynamic,
      groupName: shouldUseLegacyConfig ? tile.yGroupName : currentAxisData.groupName,
      label: currentAxisData.label || "Left Y Axis",
      movingAverage: shouldUseLegacyConfig ? (tile.yMovingAverage || false) : (currentAxisData.movingAverage || false),
      movingAverageValue: shouldUseLegacyConfig ? tile.yMovingAverageValue : currentAxisData.movingAverageValue,
      symbolList: shouldUseLegacyConfig ? (tile.ySymbolList || []) : (currentAxisData.symbolList || []),
    })
  }

  const getSeasonalityBackwardCompatibleTile = tile => {
    const basicChartType = tile?.basicChartType ? tile.basicChartType : tile?.isSeasonality ? chartCustomInsightActions.BASIC_CHART_TYPES.SEASONALITY.value : chartCustomInsightActions.BASIC_CHART_TYPES.COMPOSED.value
    if(basicChartType !== chartCustomInsightActions.BASIC_CHART_TYPES.SEASONALITY.value) {
      return tile;
    }

    const leftAxis = tile.leftAxis || EMPTY_TILE[TILE_TYPES.CHART].leftAxis,
          leftAxisData = leftAxis.data || [],
          currentAxisData = leftAxisData[0] || {},
          migratedAxisData = getSeasonalityAxisData({ currentAxisData, tile }),
          migratedLeftAxis = ReduxService.updateObject(leftAxis, { data: leftAxisData.length > 0 ? leftAxisData.updateInList(migratedAxisData, 0) : leftAxisData.add(migratedAxisData) })

    return ReduxService.updateObject(tile, { leftAxis: migratedLeftAxis })
  }

  const getChartBandBackwardCompatibleTile = tile => {
    const legacyFields = [
      "seasonalityIsSpreadBandEnabled",
      "seasonalitySpreadBandExcludedYears",
      "seasonalitySpreadBandMax",
      "seasonalitySpreadBandMin",
      "seasonalitySpreadBandUserSelection"
    ]
    if(!legacyFields.some(field => tile?.[field] !== undefined)) {
      return tile
    }
    const migratedTile = ReduxService.updateObject(tile, {
      bandBasedOn: tile.bandBasedOn === undefined ? basicCustomInsightConsts.BAND_BASED_ON.CHART_DATA.value : tile.bandBasedOn,
      bandExcludedYears: tile.bandExcludedYears === undefined ? tile.seasonalitySpreadBandExcludedYears : tile.bandExcludedYears,
      bandMax: tile.bandMax === undefined ? tile.seasonalitySpreadBandMax : tile.bandMax,
      bandMin: tile.bandMin === undefined ? tile.seasonalitySpreadBandMin : tile.bandMin,
      bandUserSelection: tile.bandUserSelection === undefined ? tile.seasonalitySpreadBandUserSelection : tile.bandUserSelection,
      isBandEnabled: tile.isBandEnabled === undefined ? tile.seasonalityIsSpreadBandEnabled : tile.isBandEnabled
    })
    legacyFields.forEach(field => delete migratedTile[field])
    return migratedTile
  }

  const getChartNormalizationBackwardCompatibleTile = tile => {
    if(tile?.normalizationLastType !== undefined && tile?.normalizationLastTypeAmount !== undefined) {
      return tile
    }
    const axisWithNormalizationPeriod = [tile?.leftAxis, tile?.rightAxis].find(axis => axis?.normalizationLastType !== undefined || axis?.normalizationLastTypeAmount !== undefined)
    if(!axisWithNormalizationPeriod) {
      return tile
    }
    return ReduxService.updateObject(tile, {
      normalizationLastType: tile.normalizationLastType === undefined ? axisWithNormalizationPeriod.normalizationLastType : tile.normalizationLastType,
      normalizationLastTypeAmount: tile.normalizationLastTypeAmount === undefined ? axisWithNormalizationPeriod.normalizationLastTypeAmount : tile.normalizationLastTypeAmount
    })
  }

  const getEffectiveAxisDots = axis => axis?.dots === undefined ? !(axis?.connectNulls ?? true) : axis.dots
  const removeLegacyAxisDots = axis => {
    if(axis?.dots === undefined) {
      return axis
    }
    const normalizedAxis = { ...axis }
    delete normalizedAxis.dots
    return normalizedAxis
  }

  const normalizeChartDots = tile => {
    if(tile?.type !== TILE_TYPES.CHART) {
      return tile
    }
    const normalizedTile = tile.dots === undefined
      ? ReduxService.updateObject(tile, {
        dots: Boolean(getEffectiveAxisDots(tile.leftAxis) || getEffectiveAxisDots(tile.rightAxis))
      })
      : tile
    const leftAxis = removeLegacyAxisDots(normalizedTile.leftAxis),
          rightAxis = removeLegacyAxisDots(normalizedTile.rightAxis)
    if(leftAxis === normalizedTile.leftAxis && rightAxis === normalizedTile.rightAxis) {
      return normalizedTile
    }
    return ReduxService.updateObject(normalizedTile, { leftAxis, rightAxis })
  }

  const normalizeChartAreaDiff = tile => {
    const hasAreaDiffFormatting = tile?.conditionalFormatting?.some(item => Object.values(chartCustomInsightActions.APPLY_TO_AREA_DIFF).some(areaDiff => areaDiff.value === item?.applyTo))
    if(tile?.type !== TILE_TYPES.CHART || (tile.withAreaDiff !== true && !hasAreaDiffFormatting)) {
      return tile
    }
    return ReduxService.updateObject(tile, {
      conditionalFormatting: chartCustomInsightActions.normalizeAreaDiffFormatting({ conditionalFormatting: tile.conditionalFormatting, withAreaDiff: tile.withAreaDiff })
    })
  }

  const normalizeCurveChartCsvHeaders = tile => {
    if(tile?.basicChartType !== chartCustomInsightActions.BASIC_CHART_TYPES.FORWARD_CURVE.value || !Array.isArray(tile.csvHeaders)) {
      return tile
    }
    const defaultHeaders = basicCustomInsightConsts.DEFAULT_CSV_HEADERS_CURVE_CHART,
          normalizedHeaders = normalizeCurveCsvHeaders({ csvHeaders: tile.csvHeaders, removeSymbolHeaders: true }),
          csvHeaders = defaultHeaders.concat(normalizedHeaders.filter(header => !defaultHeaders.some(defaultHeader => defaultHeader.value === header?.value)))
    return JSON.stringify(csvHeaders) === JSON.stringify(tile.csvHeaders) ? tile : ReduxService.updateObject(tile, { csvHeaders })
  }

  const normalizeCurveConditionalFormatting = tile => {
    if(tile?.basicChartType !== chartCustomInsightActions.BASIC_CHART_TYPES.FORWARD_CURVE.value || !Array.isArray(tile?.conditionalFormatting)) {
      return tile
    }
    const curvesWithIndex = chartCustomInsightActions.APPLY_TO_CURVES.CURVES_WITH_INDEX.value,
          conditionalFormatting = tile.conditionalFormatting.map(item => {
            if(item?.applyTo !== curvesWithIndex || item?.conditionalColorPalette === undefined) {
              return item
            }
            return ReduxService.updateObject(item, {
              color: item.color || item.conditionalColorPalette?.colors?.[0],
              conditionalColorPalette: undefined
            })
          })
    return conditionalFormatting.some((item, index) => item !== tile.conditionalFormatting[index])
      ? ReduxService.updateObject(tile, { conditionalFormatting })
      : tile
  }

  const normalizeChartTileConfig = ({ inputParams = {}, tile }) => {
    if(tile?.type !== TILE_TYPES.CHART) {
      return tile
    }
    const chartType = tile.basicChartType || (tile.isSeasonality
      ? chartCustomInsightActions.BASIC_CHART_TYPES.SEASONALITY.value
      : chartCustomInsightActions.BASIC_CHART_TYPES.COMPOSED.value)
    let normalizedTile = ReduxService.updateObject(tile, { basicChartType: chartType })
    normalizedTile = normalizeChartDots(normalizedTile)
    normalizedTile = normalizeChartAreaDiff(normalizedTile)
    normalizedTile = normalizeCurveChartCsvHeaders(normalizedTile)
    normalizedTile = normalizeCurveConditionalFormatting(normalizedTile)
    normalizedTile = getChartBandBackwardCompatibleTile(normalizedTile)
    normalizedTile = ReferenceDataService.getMigratedTile({ inputParams, tile: normalizedTile })
    normalizedTile = getChartNormalizationBackwardCompatibleTile(normalizedTile)
    return normalizedTile
  }
  
  const applyBackwardCompatibility = (content, skipDiagramBuild = false) => dispatch => {
    const inputParams = Object.assign({}, content.inputParams || {})
    const newContent = 
      ReduxService.updateObject(content, {
        tiles: content.tiles.map((tile, tileIndex) => {
          let newTile = Object.assign({}, tile)
          newTile.actions = (tile.actions || []).map(action => {
            if(!action.actionName) {
              return ReduxService.updateObject(action, { actionName: action.type })
            }
            return action;
          })
          if(newTile.sourceTileId) {
            newTile = ReduxService.updateObject(newTile, { sourceInputParamsId: newTile.sourceTileId })
            delete newTile.sourceTileId;
          }
          if(!newTile.id) {
            newTile = ReduxService.updateObject(newTile, { id: CommonService.generateUID() })
          }
          if(!newTile.tileWidth) {
            newTile = ReduxService.updateObject(newTile, { tileWidth: newTile.sectionSize === "full" ? basicCustomInsightConsts.TILE_WIDTH.FULL : basicCustomInsightConsts.TILE_WIDTH.HALF })
            delete newTile.sectionSize;
          }
          if(newTile.downloadable === undefined) {
            newTile = ReduxService.updateObject(newTile, { downloadable: EMPTY_TILE[newTile.type]?.downloadable })
          }
          if(!newTile.tileHeight) {
            let tileHeight;
            if(newTile.sectionHeight === "full") {
              tileHeight = basicCustomInsightConsts.TILE_HEIGHT.FULL;
            } else if(newTile.sectionHeight === "half") {
              tileHeight = basicCustomInsightConsts.TILE_HEIGHT.HALF;
            } else if(newTile.sectionHeight && Number(newTile.sectionHeight) > 1000) {
              tileHeight = basicCustomInsightConsts.TILE_HEIGHT.FULL;
            } else if(newTile.sectionHeight && Number(newTile.sectionHeight) < 500) {
              tileHeight = basicCustomInsightConsts.TILE_HEIGHT.QUARTER;
            } else {
              tileHeight = basicCustomInsightConsts.TILE_HEIGHT.HALF;
            }
            newTile = ReduxService.updateObject(newTile, { tileHeight })
            delete newTile.sectionHeight;
          }
          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.TABLE && newTile.clickForDetailsTileId !== undefined) {
            newTile = Object.assign({}, newTile, {
              clickForDetailsTileIds: [newTile.clickForDetailsTileId]
            })
          }
          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.AUTO_PIPELINE && newTile.withLinkToPipeline === true) {
            delete newTile.withLinkToPipeline;
            newTile = ReduxService.updateObject(newTile, { resultsAction: basicCustomInsightConsts.AUTO_PIPELINE_RESULTS_ACTION.OPEN_SOURCE_PIPELINE })
          }
          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.TABLE && newTile.source?.type === basicCustomInsightConsts.TILE_SOURCE_TYPES.EDITOR) {
            newTile = ReduxService.updateObject(newTile, {
              csvHeaders: normalizeCurveCsvHeaders({ csvHeaders: newTile.csvHeaders })
            })
            newTile = Object.assign({}, newTile, {
              columns: newTile.columns.map(column => {
                // column.columnWidth = 90 - use to set some default
                if(column.columnAsyncFilters || !column.columnAsyncKey) {
                  return column;
                } else {
                  delete column.columnAsyncKey
                  delete column.columnAsyncKeyType
                  delete column.columnAsyncColumn
                  return ReduxService.updateObject(column, {
                    columnAsyncFilters:  [{
                      key: column.columnAsyncKey,
                      type: column.columnAsyncKeyType,
                      column: column.columnAsyncColumn,
                      isTable: true
                    }]
                  });
                }
              })
            })
          }
          // do not touch next line condition as it may have unexpected results -> migrating very old tables to the new ones, may clean the data
          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.TABLE && newTile.optionalText !== undefined) {
            newTile = Object.assign({}, newTile, {
              columns: getColumnConfigs(newTile.columns),
              rowConfigs: getRowConfigs(newTile.rowConfigs),
              conditionalFormatting: getConditionalFormatting({ columns: newTile.columns, rowConfigs: newTile.rowConfigs }), 
              clickForDetailsTileIds: [newTile.clickForDetailsTileId]
            })
            delete newTile.numberOfRows
            delete newTile.optionalText
            delete newTile.optionalTextColor
            delete newTile.optionalTextFontSize
            delete newTile.optionalTextHorizontalPosition
            delete newTile.optionalTextStyle
            delete newTile.optionalTextVerticalPosition
            delete newTile.todayDateFormat
            delete newTile.todayTimezone
            delete newTile.dataprep
            delete newTile.variables
            delete newTile.values
            delete newTile.clickForDetailsTileId
            return newTile;
          }

          // moving clickForDetails configuration to contextMenuActions as single item
          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.TABLE && newTile?.clickForDetailsEnabled && newTile?.clickForDetailsTileIds !== undefined && newTile?.clickForDetailsTileIds?.length > 0) {
            newTile = Object.assign({}, newTile, {
              contextMenuActions: [
                ...(newTile?.contextMenuActions !== undefined ? newTile.contextMenuActions : []),
                {
                  clickForDetailsEnabled: newTile.clickForDetailsEnabled, 
                  type: basicCustomInsightConsts.TABLE_CONTEXT_MENU_ACTIONS.PREVIEW_DETAILS.value,
                  tileIds: newTile.clickForDetailsTileIds,
                  scrollOnPreview: newTile.scrollOnPreview,
                  scrollOnPreviewTileId: newTile.scrollOnPreviewTile
                }
              ],
              customActionsEnabled: true
            })
            delete newTile.clickForDetailsEnabled
            delete newTile.clickForDetailsTileIds
            delete newTile.scrollOnPreview
            delete newTile.scrollOnPreviewTile
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.TABLE){
            newTile = Object.assign({}, newTile, {
              ...(newTile?.csvFile !== undefined ? { 
                source: {
                  value: newTile.csvFile,
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.FILE,
                },
              } : undefined),
              ...(newTile?.sourceInputParamsId !== undefined ? { 
                source: {
                  value: {
                    id: newTile.sourceInputParamsId
                  },
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.SOURCE_TILE,
                },
              } : undefined),
            })

            delete newTile.csvFile;
            delete newTile.sourceInputParamsId;
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.STATS){
            newTile = Object.assign({}, newTile, {
              ...(newTile?.csvFile !== undefined ? { 
                source: {
                  value: newTile.csvFile,
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.FILE,
                },
              } : undefined),
              ...(newTile?.sourceInputParamsId !== undefined ? { 
                source: {
                  value: {
                    id: newTile.sourceInputParamsId
                  },
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.SOURCE_TILE,
                },
              } : undefined),
            })

            delete newTile.csvFile;
            delete newTile.sourceInputParamsId;
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.FTL) {
            newTile.type = basicCustomInsightConsts.TILE_TYPES.CODE
          }
          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.CODE && !newTile.codeType) {
            newTile.codeType = basicCustomInsightConsts.CODE_TYPES.HTML.value
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.CODE){
            newTile = Object.assign({}, newTile, {
              ...(newTile?.dlTemplate !== undefined ? { 
                source: {
                  value: newTile.dlTemplate,
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.FILE,
                },
              } : undefined),
              ...(newTile?.ftlContent !== undefined ? { 
                source: {
                  value: {
                    editorContent: newTile.ftlContent
                  },
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.EDITOR,
                },
              } : undefined),
            })

            delete newTile.ftlContent
            delete newTile.dlTemplate;
            delete newTile.templateFromDl;
            delete newTile.templateId;
            delete newTile.fileName;
          }


          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.CHART) {
            newTile = normalizeChartTileConfig({ inputParams, tile: newTile })
            newTile = ReduxService.updateObject(newTile, {
              dataprep: newTile?.source === chartCustomInsightActions.CHART_SOURCES.FILE.value ? undefined : newTile?.dataprep,
              source: newTile?.source !== chartCustomInsightActions.CHART_SOURCES.FILE.value && newTile?.source !== chartCustomInsightActions.CHART_SOURCES.SOURCE_TILE.value && typeof newTile?.source !== "object" ? chartCustomInsightActions.CHART_SOURCES.DATA_PREP.value : newTile?.source,
              sourceFile: newTile?.source !== chartCustomInsightActions.CHART_SOURCES.FILE.value && newTile?.source !== chartCustomInsightActions.CHART_SOURCES.SOURCE_TILE.value ? undefined : newTile?.sourceFile,
              leftAxis: ReduxService.updateObject(newTile.leftAxis, { domain: basicCustomInsightConsts.DOMAINS.find(d => d.value === newTile.leftAxis.domain || JSON.stringify(d.formula) === JSON.stringify(newTile.leftAxis.domain))?.value }),
              rightAxis: ReduxService.updateObject(newTile.rightAxis, { domain: basicCustomInsightConsts.DOMAINS.find(d => d.value === newTile.leftAxis.domain || JSON.stringify(d.formula) === JSON.stringify(newTile.rightAxis.domain))?.value }),
            })
            newTile = getSeasonalityBackwardCompatibleTile(newTile)
            delete newTile.isSeasonality
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.CHART){
            if(newTile.source === basicCustomInsightConsts.TILE_SOURCE_TYPES.SOURCE_TILE){
              newTile.source = {
                value: {
                  id: newTile.sourceInputParamsId
                },
                type: basicCustomInsightConsts.TILE_SOURCE_TYPES.SOURCE_TILE,
              }
            }
            if(newTile.source === basicCustomInsightConsts.TILE_SOURCE_TYPES.FILE){
              newTile.source = {
                value: newTile.sourceFile,
                type: basicCustomInsightConsts.TILE_SOURCE_TYPES.FILE,
              }
            }
            if(newTile.source === basicCustomInsightConsts.TILE_SOURCE_TYPES.DATA_PREP){
              newTile.source = {
                value: newTile.dataprep,
                type: basicCustomInsightConsts.TILE_SOURCE_TYPES.DATA_PREP,
              }
            }

            delete newTile.dataprep;
            delete newTile.sourceFile;
            delete newTile.sourceTile;
            delete newTile.sourceInputParamsId;
          }

          // migration of output configuration
          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.CHART){
            if(newTile.output === undefined) {
              newTile.output = {}
            }
            if(newTile.legendSize !== undefined){
              newTile.output.legendSize = newTile.legendSize
            }
            if(newTile.titleSize !== undefined){
              newTile.output.titleSize = newTile.titleSize
            }

            delete newTile.legendSize;
            delete newTile.titleSize;
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.PDF){
            newTile = Object.assign({}, newTile, {
              ...(newTile?.pdfFile !== undefined ? { 
                source: {
                  value: newTile.pdfFile,
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.FILE,
                },
              } : undefined),
            })

            delete newTile.pdfFile;
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.IMAGE){
            newTile = Object.assign({}, newTile, {
              ...(newTile?.imageFile !== undefined ? { 
                source: {
                  value: newTile.imageFile,
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.FILE,
                },
              } : undefined),
            })

            delete newTile.imageFile;
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.TEXT) {
            if(newTile.markdownId && newTile.markdownFromDl === undefined) {
              newTile = Object.assign({}, newTile, {
                markdownFromDl: false,
                dlMarkdownFile: undefined
              })
            }
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.TEXT){
            newTile = Object.assign({}, newTile, {
              ...(newTile?.dlMarkdownFile !== undefined && !!newTile?.markdownFromDl ? { 
                source: {
                  value: {
                    name: newTile?.dlMarkdownFile?.name,
                    groupName: newTile?.dlMarkdownFile?.groupName,
                  },
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.FILE,
                },
              } : undefined),
              ...(newTile?.dlMarkdownFile === undefined && newTile?.markdownFromDl === false ? { 
                source: {
                  value: {
                    name: newTile?.fileName
                  },
                  type: basicCustomInsightConsts.TILE_SOURCE_TYPES.EDITOR,
                },
              } : undefined),
            })

            delete newTile.dlMarkdownFile;
            delete newTile.markdownFromDl;
            delete newTile.markdownId;
            delete newTile.fileName;
            delete newTile.content;
          }

          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.INPUT_PARAMS) {
            delete newTile.downloadable
            delete newTile.partners
            delete newTile.tileHeight
            delete newTile.tileWidth
            delete newTile.titleTooltip
            delete newTile.titleTooltipText
            delete newTile.titleTooltipUrl
            delete newTile.type
            if(!newTile.basicInputParamsType) {
              newTile.basicInputParamsType = inputParamsCustomInsightActions.BASIC_INPUT_PARAM_TYPES.TS.value
            }
            inputParams[newTile.id] = newTile
            delete inputParams[newTile.id].id
            return undefined;
          }
          if(newTile.type === basicCustomInsightConsts.TILE_TYPES.DIAGRAM && !skipDiagramBuild) {
            const ToastsStore = dispatch(globalActions.getToastsStore())
            const diagram = new Diagram(ToastsStore)
            const nodeObjects = []
            Object.entries(newTile.nodes || {}).forEach(([nodeId, node], index) => {
              const position = newTile.positions[nodeId] || { x: 150 + 250 * index, y: 200 }
              nodeObjects.push(dispatch(diagramCustomInsightActions.getNode({ point: new Point(position.x, position.y) , nodeType: node.type, tileIndex, id: nodeId, withChangePosition: false })))
            })
            diagram.getActiveModel().addAll(...nodeObjects)
            const diagramLinks = []
            newTile.links.forEach((pL, plIndex) => {
              const inputNode = nodeObjects.find(node => node.getId() === pL.input.task), 
                    portInput = inputNode?.ports[pL.input.name], 
                    outputNode = nodeObjects.find(node => node.getId() === pL.output.task),
                    portOutput = outputNode?.ports[pL.output.name]
              if(!portOutput || !portInput) {
                return undefined;
              }
              const link = portOutput.link(portInput)
              newTile.links[plIndex].id = link.options.id
              diagramLinks.push(link)
            })
            diagram.getActiveModel().addAll(...diagramLinks)
            newTile = ReduxService.updateObject(newTile, {
              diagram
            })
            return newTile;
          }
          return newTile;
        }).filter(t => t !== undefined),
        inputParams: getInputParams(inputParams)
      })
      return newContent;
  }

  const getNewInsightDefinition = ({ insightType }) => dispatch => {
    const defaultContent = ReduxService.updateObject(basicCustomInsightConsts.INIT_CONTENT, { type: insightType })
    dispatch(onChange(basicCustomInsightConsts.ACTIVE_PANEL.ADD_TILE, 'activePanel'))
    dispatch(onChange(true, 'hasInsightWriteAccess'))
    dispatch(onChange(basicCustomInsightConsts.INIT_FILE_INFO, 'info'))
    dispatch(onChange(basicCustomInsightConsts.INIT_FILE_INFO, 'initInfo'))
    dispatch(onChange(defaultContent, 'content'))
    dispatch(onChange(defaultContent, 'initContent'))
  }

  const getInsightDefinition = ({ getInsightCall, groupName, name, version = "latest", navigate, isTemplate = false }) => async dispatch => { 
    if(!groupName || !name) {
      return Promise.resolve()
    }
    const isPublic = String(window.location.pathname).startsWith(`/${routing.public.name}`)
    return getInsightCall({ insightName: `${name}.json`, groupName, isPublic, version })
      .then(response => {
        if(!isTemplate) {
          dispatch(
            onChange(String(response.access).includes("W") && (
              dispatch(loginActions.hasAccessTo(routing.insight.routing.visualisation.name, "W", routing.insight.name)) || 
              dispatch(loginActions.hasAccessTo(routing.insight.routing.workflow.name, "W", routing.insight.name))), 
            'hasInsightWriteAccess')
          )
          dispatch(onChange(response.fileData, 'info'))
          dispatch(onChange(response.fileData, 'initInfo'))
          const backwardCompatibleContent = dispatch(applyBackwardCompatibility(response.content)),
                newContent = InsightFactory.fromPersisted({ insight: backwardCompatibleContent }).snapshot()
          dispatch(onChange(newContent, 'content'))
          dispatch(onChange(newContent, 'initContent'))
          dispatch(inputParamsCustomInsightActions.configToUserInputParams(newContent.inputParams))

        }
        return response;
      })
      .catch(e => {
        console.error(e)
        navigate?.(DashboardLinkFactory.insight.list({ baseUrl: "" })) // in one scenario we do not want to navigate
      })
  }

  const getReadableType = tileType => String(tileType).toLowerCase().replace("_", " ").capitaliseFirstLetter()

  const getTileConfigToExport = () => (_, getState) => {
    const selectedTileIndex = getState().insightState.customState.selectedTile,
          selectedTile = getState().insightState.customState.content?.tiles?.[selectedTileIndex] || {},
          toExport = basicCustomInsightConsts.getTileToExport(selectedTile)
    return toExport;
  }

  const getWholeTileToExport = () => (_, getState) => {
    const selectedTileIndex = getState().insightState.customState.selectedTile,
          selectedTile = getState().insightState.customState.content?.tiles?.[selectedTileIndex] || {}
    return selectedTile;
  }

  const getInputParamToExport = () => (_, getState) => {
    const activeInputParamsId = getState().insightState.customState.activeInputParamsId
    const inputParamsConfigWithId = {
      [activeInputParamsId]: getInputParamsConfig({ state: getState(), id: activeInputParamsId })
    }
    return inputParamsConfigWithId
  }

  const getInputParamConfigToExport = () => dispatch => {
    const inputParamsConfigWithId = dispatch(getInputParamToExport())
    const inputParamsConfig = Object.values(inputParamsConfigWithId || {})[0]
    return basicCustomInsightConsts.getTileToExport(inputParamsConfig, basicCustomInsightConsts.INPUT_PARAMS_FIELDS_CONFIG)
  }

  const importInputParamsConfig = (content = {}) => (dispatch, getState) => {
    const activeInputParamsId = getState().insightState.customState.activeInputParamsId,
          selectedTile = getState().insightState.customState.selectedTile,
          inputParamsConfig = getInputParamsConfig({ state: getState(), id: activeInputParamsId }),
          inputParamsIds = Object.keys(getState().insightState.customState.content?.inputParams),
          isConfigOnly = !!content.basicInputParamsType,
          importedInputParamsId = isConfigOnly ? undefined : Object.keys(content || {})[0],
          configFromContent = isConfigOnly ? content : Object.values(content || {})[0],
          isImportedIPDuplicate = importedInputParamsId && inputParamsIds.includes(importedInputParamsId) && !selectedTile.includes(importedInputParamsId),
          filteredConfig = configFromContent?.csvFile || configFromContent?.groupName ? configFromContent : basicCustomInsightConsts.getTileToExport(configFromContent, basicCustomInsightConsts.INPUT_PARAMS_FIELDS_CONFIG),
          afterFilter = filteredConfig?.presets ? { ...filteredConfig, presets: normalizeInputParamsPresets({ presets: filteredConfig.presets }) } : filteredConfig
    if(inputParamsConfig.basicInputParamsType !== afterFilter.basicInputParamsType && !configFromContent?.csvFile && !configFromContent?.groupName) {
      dispatch(globalActions.getToastsStore()).error(
        `Imported configuration input params type missmatch. Expected input params type was ${getReadableType(inputParamsConfig.basicInputParamsType)}, received: ${getReadableType(configFromContent.basicInputParamsType)}. Are you sure a proper configuration file was selected?`,
        "Import failure",
        {
          withCancel: true
        }
      );
      return;
    }
    if(isConfigOnly) {
      Object.entries(afterFilter).forEach(([key, value]) => {
        dispatch(inputParamsCustomInsightActions.onChangeInputParamsConfig(value, key, activeInputParamsId))
      })
      dispatch(globalActions.getMessageStore()).success("Configuration applied succesfully.")
    } else if(isImportedIPDuplicate) {
        dispatch(globalActions.getToastsStore()).warning(
          DUPLICATE_TILE_ID_MSG,
          "Import warning",
          {
            withCancel: false,
            confirmText: "Add tile",
            confirmAction: () => {
              dispatch(inputParamsCustomInsightActions.importInputParamsReplaceTile(activeInputParamsId, CommonService.generateUID(), afterFilter))
              dispatch(globalActions.getMessageStore()).success("Configuration applied succesfully.")
            } 
          }
        )
    } else {
      dispatch(inputParamsCustomInsightActions.importInputParamsReplaceTile(activeInputParamsId, importedInputParamsId, afterFilter))
      dispatch(globalActions.getMessageStore()).success("Configuration applied succesfully.")
    }
  }

  const importTileConfig = (content = {}) => (dispatch, getState) => {
    const selectedTileIndex = getState().insightState.customState.selectedTile,
          tileIds = (getState().insightState.customState.content?.tiles || []).map(tile => tile?.id),
          importedTileId = content?.id,
          selectedTile = getState().insightState.customState.content?.tiles?.[selectedTileIndex] || {},
          normalizedContent = normalizeChartTileConfig({ inputParams: getState().insightState.customState.content?.inputParams, tile: content }),
          afterFilter = normalizedContent?.source || normalizedContent?.basicInputParamsType ? normalizedContent : basicCustomInsightConsts.getTileToExport(normalizedContent)
    if(selectedTile.type !== afterFilter.type) {
      dispatch(globalActions.getToastsStore()).error(
        `Imported configuration tile type missmatch. Expected tile type was ${getReadableType(selectedTile.type)}, received: ${getReadableType(content.type)}. Are you sure a proper configuration file was selected?`,
        "Import failure",
        {
          withCancel: true
        }
      );
      return;
    }
    if(tileIds.includes(importedTileId) && selectedTile?.id !== importedTileId) {
      dispatch(globalActions.getToastsStore()).warning(
        DUPLICATE_TILE_ID_MSG,
        "Import warning",
        {
          withCancel: false,
          confirmText: "Add tile",
          confirmAction: () => {
            Object.entries(afterFilter).forEach(([key, value]) => {
              if(key === "leftAxis" || key === "rightAxis") {
                Object.entries(value || {}).forEach(([axisKey, axisValue]) => {
                  dispatch(chartCustomInsightActions.changeAxisData(selectedTileIndex, key === "rightAxis", axisValue, axisKey))
                })
              } else if (key === "id") {
                dispatch(onChangeTile(CommonService.generateUID(), key, selectedTileIndex))
              } else {
                dispatch(onChangeTile(value, key, selectedTileIndex))
              }
            })
            dispatch(globalActions.getMessageStore()).success("Configuration applied succesfully.")
          }
        }
      )
    } else {
      Object.entries(afterFilter).forEach(([key, value]) => {
        if(key === "leftAxis" || key === "rightAxis") {
          Object.entries(value || {}).forEach(([axisKey, axisValue]) => {
            dispatch(chartCustomInsightActions.changeAxisData(selectedTileIndex, key === "rightAxis", axisValue, axisKey))
          })
        } else {
          dispatch(onChangeTile(value, key, selectedTileIndex))
        }
      })
      dispatch(globalActions.getMessageStore()).success("Configuration applied succesfully.")
    }
  }

  // accesses may come later, we need them as params
  const resolveTilesVisibility = ({ hasWorkflowReadAccess, hasVisualisationReadAccess, hasAllTilesPublicAccess, isNew, rawTiles = [], isPublicDirectory }) => (dispatch, getState) => {
    const customState = getState().insightState.customState,
          isSelfActivationRequired = customState.info?.fields?.find(field => field.name === basicCustomInsightConsts.INSIGHT_FILE_FIELDS.IS_SELF_ACTIVATION_REQUIRED)?.value === "true",
          selfActivationTiles = customState.info?.fields?.find(field => field.name === basicCustomInsightConsts.INSIGHT_FILE_FIELDS.SELF_ACTIVATION_TILES)?.value,
          insightName = String(customState.info?.fileName || "").replace(/.json/g, ""),
          insightGroupName = customState.info?.groupName,
          isIframe = window !== window.parent
    let isSelfActivated = hasAllTilesPublicAccess
    if(!isSelfActivated) {
      isSelfActivated = getIsInsightSelfActivated({ insightName, insightGroup: insightGroupName })
      if(isSelfActivated) {
        dispatch(onChange(isSelfActivated, "hasAllTilesPublicAccess"))
      }
    }

    if((hasWorkflowReadAccess && hasVisualisationReadAccess && !isIframe && !isPublicDirectory) || isNew) {
      return rawTiles
    } else if(hasWorkflowReadAccess && !isIframe && !isPublicDirectory) {
      return rawTiles.map(tile => ReduxService.updateObject(tile, ({ hidden: !basicCustomInsightConsts.WORKFLOW_TILES.includes(tile.type) })))
    } else if(hasVisualisationReadAccess) {
      return rawTiles.map(tile => ReduxService.updateObject(tile, ({ hidden: !basicCustomInsightConsts.VISUALISATION_TILES.includes(tile.type) })))
    } else if(isPublicDirectory)  {
      const visTiles = rawTiles.map(tile => ReduxService.updateObject(tile, ({ hidden: !basicCustomInsightConsts.VISUALISATION_TILES.includes(tile.type) })))
      if(isSelfActivationRequired && !isSelfActivated) {
        if(Number(selfActivationTiles) > 0) {
          return visTiles.slice(0, Number(selfActivationTiles))
        }
        return [];
      }
      return visTiles;
    } else {
      return [];
    }
  }

  const LOAD_TEMPLATE_PREFIX = "LOAD_TEMPLATE_"

  const executeTask = ({ task, params, executeTaskCall }) => executeTaskCall({ taskName: task.name, taskGroupName: task.groupName, params, withOpenAiKey: true })

  const applyTaskResponse = ({ definition, template }) => {
    const csvParams = []
    template.mapper.forEach(({ id, paramName, parent }) => {
      if(parent === "tiles") {
        const tile = definition.tiles.find(tile => tile.id === id)
        if(tile.type === TILE_TYPES.TABLE) {
          tile.templateContent = paramName;
          csvParams.push(paramName)
        } else if(tile.type === TILE_TYPES.CHART) {
          tile.templateContent = paramName;
          csvParams.push(paramName)
        } else {
          tile.templateContent = paramName;
        }
      } else if(parent === "inputParams") {
      const inputParams = definition.inputParams[id]
        inputParams.csvFile = undefined;
        inputParams.templateContent = paramName;
        csvParams.push(paramName)
      }
    })
    return { definition, csvParams };
  }

  const parsePromise = ({ file, ...props }) => 
    new Promise((complete, error) => {
      parse(file, { 
        complete, 
        error,
        skipEmptyLines: true,
        header: true,
        worker: true,
        preview: basicCustomInsightConsts.ABSOLUTE_SIZE,
        ...props 
      });
    });

  const getParams = paramsFromUrl => {
    const params = {};
    (paramsFromUrl || "").split("|").forEach(paramsString => {
      const [keyRaw, valueRaw] = paramsString.split("=")
      params[keyRaw] = valueRaw
    });
    return params;
  }

  const getTemplateItems = ({ templateNameRaw, templateGroupNameRaw, paramsFromUrl, navigate, searchTemplateCall, getTemplateContentCall, executeTaskCall, searchTasksCall, getInsightCall }) => async dispatch => {
    const templateName = decodeURI(templateNameRaw),
          templateGroupName = decodeURI(templateGroupNameRaw),
          params = getParams(paramsFromUrl)
    const { file: template } = await dispatch(templatesInsightActions.getTemplateDefinitionCall({ 
      searchTemplateCall,
      getTemplateContentCall,
      groupName: templateGroupName, 
      templateName,
      navigate
    }))
    dispatch(onChange(template, 'template'))
    const taskExecPromises = templatesInsightActions.getTask({ taskName: template.task.name, taskGroup: template.task.groupName, searchTasksCall })
      .then(taskRaw => {
        const task = taskRaw
        task.params = task.params
          .map(p => ReduxService.updateObject(p, template.task.params.find(templateParam => templateParam.name === p.name) || {}))
          .map(p => p.isSource === "true" && !p.categorySection ? ReduxService.updateObject(p, { categorySection: templatesInsightActions.DEFAULT_CONFIGURATION_SECTIONS[0].value }) : p)
        dispatch(onChange(task, 'templateTaskDef'))
        return executeTask({ task, params, executeTaskCall })
      })
    const insightDefPromise = dispatch(getInsightDefinition({ groupName: template.insight.groupName, getInsightCall, name: template.insight.name, isTemplate: true, navigate }))
    const [taskResponseRaw, insightDefResponse] = await Promise.all([taskExecPromises, insightDefPromise])
    const taskResponse = JSON.parse(taskResponseRaw.lambdaResponse)
    return {
      taskResponse,
      insightDefResponse,
      template
    }
  }

  const parseTaskOutputsToCsvs = ({ taskResponse, csvParams, setTemplateError }) => async dispatch => {
    const id = LOAD_TEMPLATE_PREFIX + CommonService.generateUID()
    dispatch(globalActions.handleRequest({ id, noFetching: true }));
    await Promise.all(Object.entries(taskResponse).map(([paramName, fileRaw]) => {
      if(csvParams.includes(paramName)) {
        return parsePromise({ file: fileRaw }).then(res => {
          const newResult = res?.data || []
          if(newResult[newResult?.length - 1]?.length !== newResult[0]?.length) {
            newResult.pop()
          }
          if(res?.errors.length !== 0) {
            if(res?.data?.length === 0){
              dispatch(globalActions.getMessageStore()).error("No data has been received.")
            }
            return {
              paramName,
              data: {
                columns: [],
                data: [],
                isError: true
              }
            }
          } else {
            return {
              paramName,
              data: {
                data: newResult,
                columns: res?.meta?.fields || [],
              }
            }
          }
        })
      } else {
        return Promise.resolve().then(() => ({
          paramName,
          data: fileRaw
        }))
      }
    }
    )).then(res => {
      const taskResponseParsed = {}
      res.forEach(resItem => {
        taskResponseParsed[resItem.paramName] = resItem.data
      })
      dispatch(onChange(taskResponseParsed, 'templateParams'))
    })
    .catch(e => setTemplateError(e.message))
    .finally(() => dispatch(globalActions.handleRequest({ id, isResponse: true })))
  }

  const getFileInfo = ({ templateNameRaw }) => ({
    fileName: templateNameRaw.replace(".json", ""),
    fileType: "INSIGHT",
    fields: [
      {
        name: "Origin",
        value: "ETL"
      },
      {
          name: "description",
          value: "Remember to save the Insight if you want to open it later."
      }
    ]
  })

  const loadInsightFromTemplate = ({ navigate, searchTemplateCall, getTemplateContentCall, executeTaskCall, getInsightCall, setTemplateError, searchTasksCall, templateGroupNameRaw, templateNameRaw, paramsFromUrl }) => async dispatch => {
    if(!templateGroupNameRaw || !templateNameRaw) {
      console.error("Not a proper template params")
      return;
    }
    dispatch(onChange(getFileInfo({ templateNameRaw }), 'info'))
    dispatch(onChange(getFileInfo({ templateNameRaw }), 'initInfo'))
    const id = LOAD_TEMPLATE_PREFIX + CommonService.generateUID()
    dispatch(globalActions.handleRequest({ id, noFetching: true }))
    try {
      const {
        taskResponse,
        insightDefResponse,
        template
      } = await dispatch(getTemplateItems({ templateNameRaw, templateGroupNameRaw, paramsFromUrl, navigate, searchTemplateCall, getTemplateContentCall, executeTaskCall, getInsightCall, searchTasksCall }))
      const backwardCompatibleResponse = dispatch(applyBackwardCompatibility(insightDefResponse.content))
      const { definition, csvParams } = applyTaskResponse({ definition: backwardCompatibleResponse, template }),
            newContent = InsightFactory.fromPersisted({ insight: definition }).snapshot()
      await dispatch(parseTaskOutputsToCsvs({ taskResponse, csvParams, setTemplateError }))
      dispatch(onChange(newContent, 'initContent'))
      dispatch(onChange(newContent, 'content'))
      dispatch(onChange(true, 'hasInsightWriteAccess'))
      dispatch(inputParamsCustomInsightActions.configToUserInputParams(newContent.inputParams))
    } catch(e) {
      console.error(e)
      setTemplateError(e.message)
    } finally {
      dispatch(globalActions.handleRequest({ id, isResponse: true }))
    }
  }

  const closeInputParams = () => dispatch => {
    dispatch(onChange(false, 'isActiveInputParamsOpen'))
    dispatch(onChange(undefined, 'activeInputParamsId'))
    dispatch(onChange(undefined, 'expanded'))
    dispatch(onChange(undefined, 'selectedTile'))
    dispatch(onChange(basicCustomInsightConsts.ACTIVE_PANEL.TILES, 'activePanel'))
  }

  const openInputParams = id => (dispatch, getState) => {
    const activeInputParamsId = getState().insightState.customState.activeInputParamsId
    dispatch(onChange(false, 'isActiveInputParamsOpen'))
    Promise.resolve().then(() => {
      batch(() => {
        if(id === activeInputParamsId) {
          dispatch(onChange(undefined, 'activeInputParamsId'))
          dispatch(onChange(undefined, 'expanded'))
          dispatch(onChange(undefined, 'selectedTile'))
          dispatch(onChange(basicCustomInsightConsts.ACTIVE_PANEL.TILES, 'activePanel'))
        } else {
          dispatch(onChange(true, 'isActiveInputParamsOpen'))
          dispatch(onChange(id, 'activeInputParamsId'))
          dispatch(onChange(undefined, 'expanded'))
          dispatch(onChange(basicCustomInsightConsts.TILE_TYPES.INPUT_PARAMS + "-" + id, 'selectedTile'))
          dispatch(onChange(basicCustomInsightConsts.ACTIVE_PANEL.TILE_EDIT, 'activePanel'))
          dispatch(onChange(undefined, 'activeBasketId'))
          dispatch(onChange(false, 'isActiveBasketOpen'))
        }
      })
    })
  }

  const openBasket = id => (dispatch, getState) => {
    const activeBasketId = getState().insightState.customState.activeBasketId
    dispatch(onChange(false, 'isActiveBasketOpen'))
    Promise.resolve().then(() => {
      batch(() => {
        if(id === activeBasketId) {
          dispatch(onChange(undefined, 'activeBasketId'))
        } else {
          dispatch(onChange(true, 'isActiveBasketOpen'))
          dispatch(onChange(id, 'activeBasketId'))
          dispatch(closeInputParams())
        }
      })
    })
  }

  const preprocessSymbols = (symbols = {}, type) => 
    Object.entries(symbols).map(([key, values]) => {
      const normalizedValues = Array.isArray(values) ? values : [values]
      return {
        key, 
        values: normalizedValues.includes('*') ? ['*'] : normalizedValues,
        type
      }
    })
  
  const generateKeysCombinations = ({ symbols, metadatas }) => {
    const filteredSymbols = preprocessSymbols(symbols, DataStorageEnums.KEY_TYPE.SYMBOL),
          filteredMetadatas = preprocessSymbols(metadatas, DataStorageEnums.KEY_TYPE.METADATA)
    const combinations = filteredSymbols.concat(filteredMetadatas).reduce((acc, { key, values, type }) => 
      acc.flatMap(obj => 
        values.map(value => ({ ...obj, [key]: { value, type } }))
      ), 
      [{}]
    )
    return combinations.map(combination => {
      const symbols = {},
            metadatas = {}
      Object.entries(combination).forEach(([key, { value, type }]) => {
        if(type === DataStorageEnums.KEY_TYPE.SYMBOL) {
          symbols[key] = value;
        } else {
          metadatas[key] = value;
        }
      })
      return {
        symbols,
        metadatas
      }
    });
  }

  const openSystemImagePicker = onChange => {
    const input = document.createElement('input')
    input.onchange = onChange
    input.setAttribute('type', 'file');
    input.setAttribute('multiple', 'false');
    input.setAttribute('accept', 'image/png, image/jpeg') // image/jpeg is also working for jpg etc., we do not want svg
    input.style.display = 'none';
    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
  }

  const getActionFromTile = ({ tileId, actionName }) => (_, getState) => {
    const tiles = getState().insightState.customState.content?.tiles || []
    const tile = tiles.find(t => t.id === tileId)
    return tile?.actions?.find(a => a.actionName === actionName)
  }

  const getAvailableActionsForTile = ({ actions, isPdfGenerationEnabled, tileIndex }) => (_, getState) => {
    const tiles = getState().insightState.customState.content?.tiles || [],
          tile = tiles[tileIndex],
          tileType = tile?.type,
          excludedType = tileType === basicCustomInsightConsts.TILE_TYPES.CODE
            ? (isPdfGenerationEnabled ? basicCustomInsightConsts.CODE_TILE_SAVE_FILE_TYPES.HTML.value : basicCustomInsightConsts.CODE_TILE_SAVE_FILE_TYPES.PDF.value)
            : undefined

    return actions
      .map((action, originalIndex) => ({ ...action, originalIndex })) // keep original index from list
      .filter(action => !excludedType || action.contentType !== excludedType)
  }

  const getTileIndexById = ({ tileId }) => (_, getState) => {
    const tiles = getState().insightState.customState.content?.tiles || []
    const tileIndex = tiles.findIndex(t => t.id === tileId)
    return tileIndex;
  }

  const getTileSourceFile = ({ tileIndex }) => (_, getState) => {
    const editActive = getState().insightState.customState.editActive,
          tileId = getState().insightState.customState.content?.tiles?.[tileIndex]?.id,
          overwrittenSourceFile = getState().insightState.customState.tileOverwrite?.[tileId]?.source,
          configSourceFile = getState().insightState.customState.content?.tiles?.[tileIndex]?.source,
          source = !editActive && overwrittenSourceFile ? overwrittenSourceFile : configSourceFile,
          sourceType = source?.type,
          sourceInputParamsId = sourceType === basicCustomInsightConsts.TILE_SOURCE_TYPES.SOURCE_TILE ? source?.value?.id : undefined,
          inputParamsType = getState().insightState.customState.inputParams?.[sourceInputParamsId]?.inputParams?.basicInputParamsType,
          csvFile = getState().insightState.customState.inputParams?.[sourceInputParamsId]?.inputParams?.csvFile,
          sourceData = (() => {
            if(sourceType === basicCustomInsightConsts.TILE_SOURCE_TYPES.SOURCE_TILE && inputParamsType === inputParamsCustomInsightActions.BASIC_INPUT_PARAM_TYPES.FILE.value) {
              return {
                name: csvFile?.name,
                groupName: csvFile?.groupName,
              }
            } else if(sourceType === basicCustomInsightConsts.TILE_SOURCE_TYPES.FILE || sourceType === basicCustomInsightConsts.TILE_SOURCE_TYPES.EDITOR) {
              return {
                name: source?.value?.name,
                groupName: source?.value?.groupName,
              }
            }
            return undefined;
          })()
    return sourceData;
  }

  return {
    onChange,
    ON_CHANGE,
    ON_CHANGE_TILE,
    onChangeTile,
    ON_CHANGE_TILE_ITEM,
    onChangeTileItem,
    ON_CHANGE_TILE_OVERWRITE_ITEM,
    onChangeTileOverwriteItem,
    setDataPrep,
    SET_DATA_PREP,
    ADD_TILE,
    addChartTile,
    deleteTile,
    DELETE_TILE,
    ON_CHANGE_INFO,
    onChangeInfo,
    ON_CHANGE_INFO_FIELD,
    onChangeInfoField,
    reorderTile,
    onChangeContent,
    ON_CHANGE_CONTENT,
    addTextTile,
    addEngineTileReducer,
    editEngineTile,
    editTextTile,
    editPdfTile,
    editImageTile,
    editCodeTile,
    editStatusTile,
    editStatusTileItem,
    SET_TILE_PARTNER_ASSET,
    setTilePartnerAsset,
    CLEAR_TILE_PARTNER_ASSET,
    clearTilePartnerAsset,
    clearTilePartnerAssets,
    addTableTile,
    searchValuesInDataPrep,
    getColumnsFromDataPrep,
    getSymbolsFromDataPrep,
    tickFormatter,
    tooltipFormatter,
    getKeysAndMdKeysFromDataPrep,
    getProxy,
    addCodeTile,
    addPDFTile,
    ADD_HEADER_BOX,
    addHeaderBox,
    DELETE_HEADER_BOX,
    deleteHeaderBox,
    ON_CHANGE_HEADER_BOX,
    onChangeHeaderBox,
    onChangeTileList,
    ON_CHANGE_TILE_LIST,
    setShortDataPrep,
    SET_SHORT_DATA_PREP,
    getGroupsFromDataPrep,
    onRemoveTileList,
    ON_REMOVE_TILE_LIST,
    onReorderTileList,
    ON_REORDER_TILE_LIST,
    setTableTsData,
    SET_TABLE_TS_DATA,
    getKey,
    getDataPrepIndex,
    setUpDates,
    reorderHeaderBox,
    REORDER_HEADER_BOX,
    searchMetadataInDataPrep,
    addFooter,
    ADD_FOOTER,
    ON_CHANGE_FOOTER,
    onChangeFooter,
    DELETE_FOOTER,
    deleteFooter,
    addFooterButton,
    ADD_FOOTER_BUTTON,
    onChangeFooterButton,
    ON_CHANGE_FOOTER_BUTTON,
    deleteFooterButton,
    DELETE_FOOTER_BUTTON,
    reorderFooterButton,
    REORDER_FOOTER_BUTTON,
    duplicateHeaderBox,
    DUPLICATE_HEADER_BOX,
    getInsightGroups,
    getInsightRoleGroups,
    getGroupEnvironments,
    addImageTile,
    DUPLICATE_TILE,
    duplicateTile,
    addAutoPipelineTile,
    addStatusTile,
    addSearchTile,
    onAddTileList,
    ON_ADD_TILE_LIST,
    getFullSymbols,
    clearChartTile,
    addDiagramTile,
    clearWithId,
    CLEAR_WITH_ID,
    getInsightDefinition,
    getTileConfigToExport,
    importTileConfig,
    ANY,
    setTileName,
    resolveTilesVisibility,
    loadInsightFromTemplate,
    LOAD_TEMPLATE_PREFIX,
    getParams,
    getNewInsightDefinition,
    openInputParams,
    generateKeysCombinations,
    openBasket,
    openSystemImagePicker,
    addStatsTile,
    onChangeTileSourceValue,
    getActionFromTile,
    getTileIndexById,
    getTileSourceFile,
    getWholeTileToExport,
    getInputParamToExport,
    getInputParamConfigToExport,
    getNewTileName,
    importInputParamsConfig,
    getAvailableActionsForTile,
    applyBackwardCompatibility
  }
})()
